(function ($, window, document) {
	const $html = $('html');
	const $win = $(window);
	const $doc = $(document);
	const $header = $('.header');
	let isNormalScroll = true;

	gsap.registerPlugin(ScrollTrigger);

	/**
	 * Handler to trigger "widthResize" event when the width of the element changes.
	 * // iOs device window resize helper
	 */
	$.event.special.widthResize = {
		setup: function() {
			const $this = $(this);
			$this.data('currentWidth', $this.width());

			$this.on('resize.widthResize', function() {
				const newWidth = $this.width();
				const prevWidth = $this.data('currentWidth');

				if (newWidth !== prevWidth) {
					$this.data('currentWidth', newWidth).trigger('widthResize');
				}
			});
		},
		teardown: function() {
			$(this).off('resize.widthResize');
		}
	};

	/**
	 * Get window viewport width.
	 * @returns {Number}
	 */
	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	/**
	 * Get window viewport height.
	 * @returns {Number}
	 */
	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}

	/**
	 * Update cursor trail line points.
	 * @param {Object} event
	 * @returns {Void}
	 */
	function updateCursorTrailPoints(event) {
		const mouseX = event.clientX;
		const mouseY = event.clientY;

		pointsArray.push(mouseX + ',' + mouseY);

		if (pointsArray.length > maxPointsCount) {
			pointsArray.shift();
		}

		$cursorTrailLine.attr('points', pointsArray.join(' '));
	}

	/**
	 * Get the scroll progress of an element.
	 * @param {Object} element
	 * @returns {number} - [0, 1]
	 */
	function getElementInnerScrollProgress(element) {
		if (!$(element).length) {
			return -1;
		}

		const currentScrollTop = $win.scrollTop();
		const elementTopPos = $(element).offset().top;
		const elementBottomPos = elementTopPos + $(element).outerHeight(true);

		return Math.max(0, Math.min(1, (currentScrollTop - elementTopPos) / (elementBottomPos - window_height())));
	}

	/**
	 * Set Computed Transform values as data attributes.
	 * @param {Object} elements
	 * @param {Boolean} isGetComputed - get initial values.
	 * @returns {Void}
	 */
	function setTransformData(elements, isGetComputed) {
		$(elements).each(function() {
			const $this = $(this);

			//Reset values
			if(isGetComputed) {
				$this.css('transform', '');
			}

			//Get CSS transform values
			const transformMatrix = $this.css('transform')
					.match(/matrix\((.+)\)/)[1]
					.split(',')
					.map(parseFloat);

			// Set transform values data attributes
			$this.data('transform', {
				x: transformMatrix[4],
				y: transformMatrix[5],
				scaleX: transformMatrix[0],
				scaleY: transformMatrix[3]
			});
		});
	}

	/**
	 * Set Computed Transform values as data attributes.
	 * @param {Object} elements
	 * @param {Boolean} isGetComputed - get initial values.
	 * @returns {Void}
	 */
	function setScalableData(elements, isGetComputed) {
		$(elements).each(function() {
			const $this = $(this);

			//Reset values
			if(isGetComputed) {
				$this.css('left', '');
				$this.css('bottom', '');
				$this.css('width', '');
				$this.css('height', '');
			}

			//Get CSS transform values
			const data = {
				left: parseFloat($this.css('left'))	,
				bottom: parseFloat($this.css('bottom')),
				width: parseFloat($this.css('width')),
				height: parseFloat($this.css('height')),
			}

			// Set transform values data attributes
			$this.data('left', data.left);
			$this.data('bottom', data.bottom);
			$this.data('width', data.width);
			$this.data('height', data.height);
		});
	}

	function easeInOutQuad(t) {
		return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	}
	
	// Debounce function to limit the rate of function calls
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}
	
	function updateScalableElementsTransform(elements) {
		$(elements).each(function() {
			const $this = $(this);
			const scrollProgress = getElementInnerScrollProgress($this.closest('.js-scalable-container'));
			
			// Apply easing to the scroll progress
			const easedProgress = easeInOutQuad(scrollProgress);
	
			const initialTransform = $this.data('transform');
			const initialWidth = $this.data('width');
			const initialHeight = $this.data('height');
			const initialLeft = $this.data('left');
			const initialBottom = $this.data('bottom');
	
			// Convert initial values to vw for width and lvh for height
			const initialWidthVw = (initialWidth / window.innerWidth) * 100;
			const initialHeightLvh = (initialHeight / window.innerHeight) * 100;
			const initialLeftVw = (initialLeft / window.innerWidth) * 100;
			const initialBottomLvh = (initialBottom / window.innerHeight) * 100;
	
			const targetTransform = {
				x: 0,
				y: 0,
				scaleX: 1,
				scaleY: 1,
				width: 100, // 100vw
				height: 100, // 100svh
				left: 0,
				bottom: 0,
			};
	
			const currentTransform = {
				x: calculateInterpolateValue(initialTransform.x, targetTransform.x, easedProgress),
				y: calculateInterpolateValue(initialTransform.y, targetTransform.y, easedProgress),
				scaleX: calculateInterpolateValue(initialTransform.scaleX, targetTransform.scaleX, easedProgress),
				scaleY: calculateInterpolateValue(initialTransform.scaleY, targetTransform.scaleY, easedProgress),
				width: calculateInterpolateValue(initialWidthVw, targetTransform.width, easedProgress),
				height: calculateInterpolateValue(initialHeightLvh, targetTransform.height, easedProgress),
				left: calculateInterpolateValue(initialLeftVw, targetTransform.left, easedProgress),
				bottom: calculateInterpolateValue(initialBottomLvh, targetTransform.bottom, easedProgress),
			};
	
			$this.css({
				'transform': `translate3d(${currentTransform.x}px, ${currentTransform.y}px, 0)
							scale(${currentTransform.scaleX}, ${currentTransform.scaleY})`,
				'height': `${currentTransform.height}svh`,
				'width': `${currentTransform.width}vw`,
				'left': `${currentTransform.left}vw`,
				'bottom': `${currentTransform.bottom}lvh`,
			});
		});
	}

	/**
	 * Interpolates a value between current and target based on a ratio.
	 * @param {Number} currentValue
	 * @param {Number} targetValue
	 * @param {Number} ratio - Fraction between two values.
	 * @returns {Number}
	 */
	function calculateInterpolateValue(currentValue, targetValue, ratio) {
		return currentValue + (targetValue - currentValue) * ratio;
	}


	/**
	 * Get the index of the most visible element within a collection of elements
	 * @param {Array} elements
	 * @returns {Number} - elementi ndex
 	 */
	function getMostVisibleElementIndex(elements) {
		let maxIntersectionRatio = 0;
		let mostVisibleElementIndex = 0;

		elements.each(function(index) {
			const entry = observerMap.get(this);

			if (!entry || !entry.isIntersecting) {
				return;
			}

			if (entry.intersectionRatio >= maxIntersectionRatio) {
				maxIntersectionRatio = entry.intersectionRatio;
				mostVisibleElementIndex = index;
			}
		});

		const containerOffsetTop = $(elements.first().parent()).offset().top;
		const containerOffsetBottom = containerOffsetTop + $(elements.first().parent()).height();

		if ($win.scrollTop() + (window_height() / 2) < containerOffsetTop) {
			return (elements.length + 1) * -1;
		} else if ($win.scrollTop() + window_height() > containerOffsetBottom) {
			return elements.length - 1;
		}

		return mostVisibleElementIndex;
	};

	/**
	 * Get the intersection ratio of an element
	 * @param {*} element
	 * @returns {Number} [0, 1]
	 */
	function getElementIntersectionRatio(element) {
		const elementBoundingRect = element[0].getBoundingClientRect();
		const distanceFromTop = Math.max(0, elementBoundingRect.top);
		const distanceFromBottom = Math.min(window_height(), elementBoundingRect.bottom);
		const visibleHeight = Math.max(0, distanceFromBottom - distanceFromTop);

		const intersectionRatio = Math.min(1, Math.max(0, visibleHeight / element.height()));

		return intersectionRatio;
	}

	/**
	 * Determine whether an element is fully visible within viewport
	 * @param {Object} element
	 * @returns {Boolean}
	 */
	function isElementVisibleInView(element) {
		const isScrollPositionBelowTop = element.offset().top <= ($win.scrollTop());
		const isScrollPositionAboveBottom = element.offset().top + element.outerHeight() >= ($win.scrollTop() + window_height());

		return isScrollPositionBelowTop && isScrollPositionAboveBottom;
	}

	/**
	 * Init Sliders
	 * @returns {Void}
	 */
	function initSliders() {

		$('.js-entry-slider').each(function() {
			const $this = $(this);
			const $slider = $this.find('.slider__slides');

			if ($slider.length && !$slider.hasClass('slick-initialized')) {
				$slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					fade: true,
					swipeToSlide: true,
					autoplay: false,
					dots: false,
					arrows: false,
				});
			}
		})

		$('.js-slider-media').each(function() {
			const $this = $(this);
			const $slider = $this.find('.slider__slides');
			const isFade = $this.hasClass('is-fade');
			const isVariableWidth = $this.hasClass('slider-media--alt');

			if ($slider.length && !$slider.hasClass('slick-initialized')) {
				$slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					fade: isFade,
					variableWidth: isVariableWidth,
					swipeToSlide: true,
					focusOnSelect: isVariableWidth,
					swipeToSlide: true,
					autoplay: false,
					dots: true,
					appendDots: $this.find('.slider__dots'),
					arrows: true,
					prevArrow: false,
					nextArrow: $this.find('.slider__next'),
					rows: 0,
				});

				if($this.hasClass('js-slider-media--autoplay')) {
					const observer = new IntersectionObserver((entries, observer) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								$slider.slick('slickPlay');
								$slider.addClass('is-autoplay');
							}
						});
					});

					observer.observe($slider.get(0));
				}

				if($this.closest('section').hasClass('js-projects')) {

					$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
						// Find closes .js-entry-slider slider and change slide to same current slide
						const $slider = $this.closest('section').find('.js-entry-slider .slider__slides');

						if($slider.length) {
							$slider.slick('slickGoTo', nextSlide);
						}
					});

					$slider.on('afterChange', function(event, slick, currentSlide) {
						if($slider.hasClass('is-autoplay')) {
							$this.closest('section')
								.find('.js-project-nav li')
								.eq(currentSlide)
									.addClass('hover')
								.siblings()
								.removeClass('hover');
						}
					});
				}
			}
		});

		$('.section-gateway:not(.js-scroll-animation) .js-slider-gateways').each(function() {
			const $this = $(this);
			const $slider = $this.find('.slider__slides');

			if ($slider.length && !$slider.hasClass('slick-initialized')) {
				$slider.slick({
					infinite: false,
					slidesToShow: 2.115,
					slidesToScroll: 1,
					swipeToSlide: true,
					focusOnSelect: false,
					dots: false,
					arrows: true,
					prevArrow: false,
					nextArrow: $this.find('.slider__next'),
					rows: 0,
					responsive: [
						{
							breakpoint: 1023,
							settings: {
								slidesToShow: 1.18
							}
						}
					]
				});

				const animationObjects = [];
				const timeoutSpeed = $slider.slick('slickGetOption', 'speed');
				let animationTimeout;

				$slider.find('.js-lottie').each(function(i) {
					const $container = $(this);
					const index = i;

					if($container.hasClass('lottie-loaded')) {
						return;
					}

					const animation = lottie.loadAnimation({
						container: $container.get(0),
						renderer: 'svg',
						loop: false,
						autoplay: false,
						assetsPath: '',
						path: $container.data('src')
					});

					animation.setSpeed($container.data('speed'));

					$container.data('lottie', animation);
					$container.addClass('lottie-loaded');
					animationObjects.push(animation);

					$win.on('load scroll', function() {
						const winBottom = $win.scrollTop() + (window_height() * 1.4);
						const winLeft = $win.scrollLeft() + window_width();

						if (
							winBottom > $container.offset().top
							&& winLeft > $container.offset().left
						) {
							setTimeout(function() {
								animation.play();
							}, 900 * (index + 1));
						}
					});
				});

				$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					const affectedIndexes = [];
					const direction = currentSlide > nextSlide ? -1 : 1;

					if(currentSlide > nextSlide) {
						for (let i = slick.$slides.length; i > nextSlide + 1; i--) {
							affectedIndexes.push(i);
						}
					} else if (currentSlide < nextSlide) {
						for (let i = 1; i <= nextSlide; i++) {
							affectedIndexes.push(i);
						}
					}

					clearTimeout(animationTimeout);

					setTimeout(() => {
						$.each(affectedIndexes, function(index, i){
							const $animationContainer = slick.$slides.eq(i).find('.js-lottie');

							if (!animationObjects[i]) {
								animationObjects[i] = lottie.loadAnimation({
									container: $animationContainer.get(0),
									renderer: 'svg',
									loop: false,
									autoplay: false,
									path: $animationContainer.data('src'),
								});
							}

							animationObjects[i].pause();
							animationObjects[i].setSpeed($animationContainer.data('speed'));
							animationObjects[i].setDirection(direction);
							animationObjects[i].play();
						});
					}, direction == 1 ? timeoutSpeed / 2 : 0);
				});
			}
		});

		$('.js-slider-posts').each(function() {
			const $this = $(this);
			const $slider = $this.find('.slider__slides');

			if ($slider.length && !$slider.hasClass('slick-initialized')) {
				$slider.slick({
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					draggable: true,
					swipeToSlide: true,
					dots: false,
					prevArrow: $this.find('.slider__slide').length > 4 ? $this.find('.slider__prev') : '',
					nextArrow: $this.find('.slider__slide').length > 4 ? $this.find('.slider__next') : '',
					rows: 0,
					responsive: [
						{
							breakpoint: 1023,
							settings: {
								slidesToShow: 2
							}
						}
					]
				});
			}
		});

		$('.js-slider-features').each(function() {
			const $this = $(this);
			const $slider = $this.find('.slider__slides');

			if(window_width() >= 1024 && $slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
				return;
			}

			if ($slider.length && !$slider.hasClass('slick-initialized') && window_width() <= 1023 ) {
				$slider.slick({
					infinite: false,
					slidesToShow: 3.23,
					slidesToScroll: 2,
					draggable: true,
					swipeToSlide: true,
					// focusOnSelect: true,
					dots: false,
					arrows: true,
					prevArrow: false,
					nextArrow: $this.find('.slider__next'),
					rows: 0,
					responsive: [
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 1.2
							}
						}
					]
				});

				const animationObjects = [];
				const timeoutSpeed = $slider.slick('slickGetOption', 'speed');
				let animationTimeout;

				$slider.find('.js-lottie').each(function(i) {
					const $container = $(this);
					const index = i;

					if($container.hasClass('lottie-loaded')) {
						$container.data('lottie').destroy();
						$container.removeClass('lottie-loaded');
					}

					const animation = lottie.loadAnimation({
						container: $container.get(0),
						renderer: 'svg',
						loop: false,
						autoplay: false,
						assetsPath: '',
						path: $container.data('src')
					});

					animation.setSpeed($container.data('speed'));

					$container.data('lottie', animation);
					$container.addClass('lottie-loaded');
					animationObjects.push(animation);

					$win.on('load scroll', function() {
						const winBottom = $win.scrollTop() + (window_height() * 0.92);
						const winLeft = $win.scrollLeft() + window_width();

						if (
							winBottom > $container.offset().top
							&& winLeft > $container.offset().left
						) {
							setTimeout(function() {
								animation.play();
							}, 600 * index);
						}
					});
				});

				$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					const affectedIndexes = [];
					const direction = currentSlide > nextSlide ? -1 : 1;
					const slidesToShow = window_width() > 768 ? 3 : 1;

					if(currentSlide > nextSlide) {
						for (let i = slick.$slides.length; i > nextSlide + slidesToShow; i--) {
							affectedIndexes.push(i);
						}
					} else if (currentSlide < nextSlide) {
						for (let i = slidesToShow + 1; i <= nextSlide + (slidesToShow - 1); i++) {
							affectedIndexes.push(i);
						}
					}

					clearTimeout(animationTimeout);

					setTimeout(() => {
						$.each(affectedIndexes, function(index, i){
							const $animationContainer = slick.$slides.eq(i).find('.js-lottie');

							if($animationContainer.length > 0) {
								const animation = $animationContainer.data('lottie');

								animation.pause();
								animation.setSpeed($animationContainer.data('speed'));
								animation.setDirection(direction);
								animation.play();
							}
						});
					}, direction == 1 ? timeoutSpeed / 2 : 0);
				});
			}
		});

		$('.section-gateway.js-scroll-animation .js-slider-gateways').each(function() {
			const $this = $(this);
			const $slider = $this.find('.slider__slides');

			if(window_width() >= 1024 && $slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
				return;
			}

			if ($slider.length && !$slider.hasClass('slick-initialized') && window_width() <= 1023) {
				$slider.slick({
					mobileFirst: true,
					slidesToShow: 1.18,
					slidesToScroll: 1,
					swipeToSlide: true,
					// focusOnSelect: true,
					infinite: false,
					dots: false,
					arrows: false,
					nextArrow: $slider.find('.slider__next'),
					rows: 0,
				});

				animationObjects = [];
				const timeoutSpeed = $slider.slick('slickGetOption', 'speed');
				let animationTimeout;

				$slider.find('.js-lottie').each(function(i) {
					const $container = $(this);
					const index = i;

					if ($container.hasClass('lottie-loaded')) {
						$container.data('lottie').destroy();
						$container.removeClass('lottie-loaded');
					}

					const animation = lottie.loadAnimation({
						container: $container.get(0),
						renderer: 'svg',
						loop: false,
						autoplay: false,
						assetsPath: '',
						path: $container.data('src')
					});

					animation.setSpeed($container.data('speed'));

					$container.data('lottie', animation);
					$container.addClass('lottie-loaded');
					animationObjects.push(animation);

					$win.on('load resize scroll', function() {
						const winBottom = $win.scrollTop() + (window_height() * 0.92);
						const winLeft = $win.scrollLeft() + window_width();

						if (
							winBottom > $container.offset().top
							&& winLeft > $container.offset().left
						) {
							setTimeout(function() {
								animation.play();
							}, 600 * index);
						}
					});
				});

				$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					const affectedIndexes = [];
					const direction = currentSlide > nextSlide ? -1 : 1;

					if(currentSlide > nextSlide) {
						for (let i = slick.$slides.length; i > nextSlide; i--) {
							affectedIndexes.push(i);
						}
					} else if (currentSlide < nextSlide) {
						for (let i = 1; i <= nextSlide; i++) {
							affectedIndexes.push(i);
						}
					}

					clearTimeout(animationTimeout);

					setTimeout(() => {
						$.each(affectedIndexes, function(index, i){
							const $animationContainer = slick.$slides.eq(i).find('.js-lottie');

							if (!animationObjects[i]) {
								animationObjects[i] = lottie.loadAnimation({
									container: $animationContainer.get(0),
									renderer: 'svg',
									loop: false,
									autoplay: false,
									path: $animationContainer.data('src'),
								});
							}

							animationObjects[i].pause();
							animationObjects[i].setSpeed($animationContainer.data('speed'));
							animationObjects[i].setDirection(direction);
							animationObjects[i].play();
						});
					}, direction == 1 ? timeoutSpeed / 2 : 0);
				});
			}
		});

		$('.section-stats .js-stats-media').each(function() {
			const $slider = $(this);

			if(window_width() <= 1023 && $slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
				return;
			}

			if ($slider.length && !$slider.hasClass('slick-initialized') && window_width() > 1023) {
				$slider.slick({
					infinite: true,
					dots: false,
					arrows: false,
					fade: true,
					cssEase: 'linear',
					autoplay: false,
					rows: 1,
				});

				const observer = new IntersectionObserver((entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							$slider.slick('slickPlay');
						}
					});
				});

				observer.observe($slider.get(0));

				$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					if(nextSlide == 0) {
						$slider.closest('section')
							.find('.js-countup > ul > li')
							.removeClass('hover');
					} else {
						$slider.closest('section')
							.find('.js-countup > ul > li')
							.eq(nextSlide-1)
								.addClass('hover')
							.siblings()
								.removeClass('hover');
					}
				});
			}
		})

		$('.slick-initialized .slick-list').each(function() {
			$(this).on('click', function(event) {
				const isLeftClicked = event.pageX - $(this).offset().left < $(this).width() / 2;

				$(this).parent().slick(isLeftClicked ? 'slickPrev' : 'slickNext');
			});
		});
	}

	initSliders();

	/**
	 * Set CSS Variable
	 * @param {String} name
	 * @param {Number} value
	 * @param {String} unit *Optional* - Type of unit
	 * @param {Object} element *Optional* - Element to set variable on
	 * @returns {Void}
	 */
	function setCSSVariable(name, value, unit, element) {
		if(typeof unit !== 'string' || unit === null) {
			unit = '';
		}

		element != null
			? element.css(`--${name}`, `${value}${unit}`)
			: $html.css(`--${name}`, `${value}${unit}`);
	}

	/**
	 * Update timeline display.
	 * @param {Object} timeline
	 * @returns {Void}
	 */
	function updateTimelineDisplay(timeline) {
		const $timeline = $(timeline);

		$timeline.toggleClass('is-fixed', isElementVisibleInView($timeline));

		const currentTimelineIndex = getMostVisibleElementIndex($timeline.find('.section-timeline'));

		const $currentNavItem = $timeline.find('.timeline__nav li').eq(currentTimelineIndex);

		const $currentTimeline = $timeline.find('.section-timeline')
			.eq(currentTimelineIndex);

		if ( !$currentTimeline.length ) {
			$timeline.find('.section-timeline').removeClass('is-current');
		} else {
			$currentTimeline.addClass('is-current')
			// .siblings()
			// 	.removeClass('is-current');

			$currentTimeline.addClass('fade-in')
			.siblings()
				.removeClass('fade-in');

			$currentNavItem.addClass('is-current')
			.siblings()
				.removeClass('is-current');
		}

		$timeline.toggleClass('is-light', $currentTimeline.length > 0 && $currentTimeline.hasClass('is-light'));
		$timeline.toggleClass('is-after', $win.scrollTop() + window_height() >= $timeline.outerHeight() + $timeline.offset().top);
	}

	/**
	 * Update custom cursor's position.
	 *
	 * @param {Event} e
	 */
	function updateCursorPosition(e) {
		$cursor.css({
			left: e.clientX,
			top: e.clientY !== undefined ? e.clientY : cursorYOnScroll,
		 });

		$cursor.cursorX = e.clientX;
		$cursor.cursorY = e.clientY !== undefined ? e.clientY : cursorYOnScroll;
	}

	/**
	 * Check if cursor is inside a container.
	 *
	 * @param {Object} container
	 * @returns {Boolean}
	 */
	function isCursorInsideContainer (container) {
		const rect = $(container)[0].getBoundingClientRect();

		return $cursor.cursorX >= rect.left &&
			   $cursor.cursorX <= rect.right &&
			   $cursor.cursorY >= rect.top &&
			   $cursor.cursorY <= rect.bottom;
	};

	/**
	 * Set Cursor Scale values
	 *
	 * @returns {Void}
	 */
	function setCursorScaleValues () {
		const cursorCenter = window_width() >= window_height()
			? $cursor.cursorX + ($cursor.width() / 2)
			: $cursor.cursorY + ($cursor.height() / 2);

		const scaleNeeded = window_width() >= window_height()
			? Math.max(cursorCenter, window_width() - cursorCenter) / $cursor.width()
			: Math.max(cursorCenter, window_height() - cursorCenter) / $cursor.height();

		const scaleFactor = window_height() == window_width()
			? 2.5
			: window_width() >= window_height()
				? window_width() * 1.1 / window_height()
				: window_height() * 1.1 / window_width();

		$cursor.css('--scale-y', scaleNeeded * scaleFactor);
		$cursor.css('--scale-x', scaleNeeded * scaleFactor);
	}

	/**
	 * Expand Cursor on page transition.
	 *
	 * @returns {Void}
	 */
	function expandCursor () {
		$externalLinks.css('pointer-events', 'none');

		$win.unbind('mousemove', updateCirclePosition);

		const currentMouseX = getMouseX();
		const currentMouseY = getMouseY();

		gsap.timeline()
			.to(outerCircleProperties, {
				duration: 0.7,
				vectorZ: -1,
				radius: 1,
				geometry: 0.43,
				onUpdate: function() {
					const vector = new THREE.Vector3(currentMouseX, currentMouseY, outerCircleProperties.vectorZ);
					vector.unproject(camera);

					circle.position.copy(vector);

					geometry.parameters.radius = outerCircleProperties.geometry;
					geometry.dispose();
					geometry = new THREE.CircleGeometry(outerCircleProperties.geometry, 128);
					circle.geometry.dispose();
					circle.geometry = geometry;
				},
				onComplete: function() {
					const vector = new THREE.Vector3(currentMouseX, currentMouseY, outerCircleProperties.vectorZ);
					vector.unproject(camera);

					circle.position.copy(vector);

					updateCirclePosition();
				}
			})
			.to(innerCircleProperties, {
				duration: 1.3,
				vectorZ: -1,
				radius: 0.43,
				onUpdate: function() {
					circle.material.uniforms.innerRadius.value = innerCircleProperties.radius;
				},
				onComplete: function () {
					outerCircleProperties.radius = .1;
					outerCircleProperties.vectorZ = 1;
					outerCircleProperties.geometry = 0.1;
					innerCircleProperties.radius = .01;
					innerCircleProperties.vectorZ = 1;
					circle.material.uniforms.innerRadius.value = 0;

					geometry.dispose();
					geometry = new THREE.CircleGeometry(.1, 128);
					circle.geometry.dispose();
					circle.geometry = geometry;

					updateCirclePosition();
					$win.bind('mousemove', updateCirclePosition);

					$externalLinks.css('pointer-events', '');
					$cursor.removeClass('is-new-page');
				}
			});
	}

	/**
	 * Sort elements by zIndex (Comparator);
	 * @returns {Number}
	 */
	function sortByZIndex(a, b) {
		const zIndexA = $(a).css('z-index') != 'auto' ? parseInt($(a).css('z-index')) : -10;
		const zIndexB = $(b).css('z-index') != 'auto' ? parseInt($(b).css('z-index')) : -10;

		return zIndexA - zIndexB;
	}

	/**
	 * Handle custom cursor's state
	 */
	let $coloredCursorContainers = $('.wrapper>[data-cursor-color], .main [data-cursor-color]').sort(sortByZIndex);
	let $stateContainers = $('.wrapper>*:not(.main), .main>*').sort(sortByZIndex);
	let $buttonContainers = $('.wrapper>*:not(.main), .main>*').sort(sortByZIndex);

	let $additionalColoredChildren = $();
	let $additionalStateChildren = $();
	let $buttons = $();

	const mergedColoredElementsArray = [];
	const mergedStateElementsArray = [];
	const mergedButtonsArray = [];

	$coloredCursorContainers.each(function() {
		const $childrenWithCursorColor = $(this).find('[data-cursor-color]');

		$.merge($additionalColoredChildren, $childrenWithCursorColor);
	});

	$stateContainers.each(function() {
		const $childrenWithCursorState = $(this).find('.is-visit, .is-explore, .is-view, .is-read, .is-learn').not('.cursor, .cursor *');

		$.merge($additionalStateChildren, $childrenWithCursorState);
	});

	$buttonContainers.each(function() {
		const $clickableChildren = $(this).find('a, button, input[type="submit"]');

		$.merge($buttons, $clickableChildren);
	});

	for (let i = 0; i < $coloredCursorContainers.length; i++) {
		mergedColoredElementsArray.push($coloredCursorContainers[i]);

		$additionalColoredChildren.each(function() {
			const $child = $(this);

			if($child.closest($coloredCursorContainers[i]).length > 0 && !mergedColoredElementsArray.includes($child)) {
				mergedColoredElementsArray.push($child);
			}
		});
	}

	for (let i = 0; i < $stateContainers.length; i++) {
		if($($stateContainers[i]).is('.header, .bar')) {
			mergedStateElementsArray.push($stateContainers[i]);
		}

		$additionalStateChildren.each(function() {
			const $child = $(this);

			if($child.closest($stateContainers[i]).length > 0 && !mergedStateElementsArray.includes($child)) {
				mergedStateElementsArray.push($child);
			}
		});
	}

	for (let i = 0; i < $buttonContainers.length; i++) {
		if($($buttonContainers[i]).is('.header, .bar')) {
			mergedButtonsArray.push($buttonContainers[i]);
		}

		$buttons.each(function() {
			const $child = $(this);

			if($child.closest($buttonContainers[i]).length > 0 && !mergedButtonsArray.includes($child)) {
				mergedButtonsArray.push($child);
			}
		});
	}

	$coloredCursorContainers = $(mergedColoredElementsArray);
	$stateContainers = $(mergedStateElementsArray);
	$buttonContainers = $(mergedButtonsArray);

	function handleCursorState() {
		let isCursorInsideAnyStateContainer = false;
		let isCursorInsideAnyColoredContainer = false;
		let isCursorInsideLink = false;

		$stateContainers.each(function() {
			const $container = $(this);

			if (isCursorInsideContainer($container)) {
				isCursorInsideAnyStateContainer = true;

				$cursor.removeClass('is-visit is-explore is-view is-read is-learn')
					.addClass($container.attr('class')
					.split(' ')
					.filter(className => className.startsWith('is-'))
					.join(' '));
			}
		});

		$buttonContainers.each(function () {
			if(isCursorInsideContainer($(this))) {
				isCursorInsideLink = !$(this).is('.header, .bar');
			}
		});

		$cursor.toggleClass('on-link', isCursorInsideLink);

		$coloredCursorContainers.each(function () {
			const $container = $(this);

			if (isCursorInsideContainer($container)) {
				isCursorInsideAnyColoredContainer = true;
				$cursor.attr('data-color', $container.data('cursor-color'));
			}
		});

		$cursor.toggleClass("is-in-marquee", isCursorInsideContainer($(".bar")));

		if (!isCursorInsideAnyStateContainer) {
			$cursor.removeClass('is-visit is-explore is-view is-read is-learn');
		}

		if (!isCursorInsideAnyColoredContainer) {
			$cursor.attr('data-color', '');
		}
	}

	/**
	 * Scroll to target animation.
	 *
	 * @param {Object} target
	 * @returns {Void}
	 */
	function scrollToTarget(target) {
		if (!target || !target.length) {
			return;
		}

		const duration = 0.7;
		expandOuterCircle(duration, 1, 0.43, true, 1000);

		setTimeout(() => {
			$win.scrollTop(target.offset().top + $('.bar').outerHeight());
		}, 1000);

		setTimeout(() => {
			isNormalScroll = true;

			$('.timeline').each(function () {
				updateTimelineDisplay($(this));
			});
		}, 1100);
	}

	/**
	 * Passive scroll to target.
	 *
	 * @param {jQuery} $target
	 * @returns {Void}
	 */
	function passiveScrollToTarget($target) {
		const distance = Math.abs($win.scrollTop() - $target.offset().top);

		$('html, body').animate({
			scrollTop: $target.offset().top
		}, (distance / window_height()) * 500, 'swing');

		$win.one('mousewheel touchmove', function() {
			$('html, body').stop();
		});
	}

	/**
	 * Set elements order indexes.
	 *
	 * @param {Object} container
	 * @param {Array} elements
	 * @returns
	 */
	function setOrderIndexes(container, elements) {
		if (!container.length) {
			return;
		}

		elements.each(function (index, el) {
			setCSSVariable('index', index, '', $(el));
		});
	}

	/**
	 * Init lotties.
	 */
	function initLotties() {
		initHeroLotties();
		initAutoplayLotties();
		initHeroPanels();
	}

	/**
	 * Init hero lotties.
	 */
	function initHeroLotties() {
		const $containers = $('.hero, .hero-intro')
			.find('.js-lottie')
			.filter(function() {
				return !$(this).parent().hasClass('hero__decoration--secondary')
			});

		$containers.each(function() {
			const $container = $(this);

			if($container.hasClass('lottie-loaded')) {
				return;
			}

			const animation = lottie.loadAnimation({
				container: $container.get(0),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				assetsPath: '',
				path: $container.data('src')
			});

			animation.setSpeed($container.data('speed'));

			animation.addEventListener('DOMLoaded', function() {
				if($container.closest('.hero, .hero-intro').length > 0) {
					const totalDelayTime = $('.hero [data-order-fade], .hero-intro [data-order-fade]').toArray().reduce((acc, el, index) => {
						return index == 1
							? acc + (parseFloat($(el).css('transition-duration')) * 1000)
							: acc + ((parseFloat($(el).css('transition-duration')) - (parseFloat($(el).css('--delay-timing')))) * 1000);
					}, 0);

					const animationDuration = (animation.getDuration(false) / $container.data('speed')) * 1000;

					setTimeout(() => {
						$('.hero, .hero-intro').find('[data-order-fade]')
							.addClass('is-visible');
					}, animationDuration * 0.2);

					$(animation).on('complete', function() {
						$('.hero').each(function() {
							const $this = $(this);
							const customDelayTime = $this.data('custom-delay');
							const afterAnimationDelay = 1400;
							const delay = customDelayTime !== undefined && customDelayTime !== '-1' ? customDelayTime : totalDelayTime + afterAnimationDelay - (animationDuration * 0.2);
	
							setTimeout(function () {

								// Disabled this featured
								if($this.find('.hero__background').length > 0 && false) {
									$this.find('.hero__inner:not(.hero__inner--no-image)')
										.addClass('is-hidden');
	
									$this.find('.js-play-btn').trigger('click');
								}
	
								$this.addClass('animation-end');
	
								const $secondaryLottie = $this.find('.hero__decoration--secondary .js-lottie');
								if($secondaryLottie.length > 0) {
									$secondaryLottie.each(function () {
										const $lottie = $(this);
	
										const secondaryAnimation = lottie.loadAnimation({
											container: $lottie.get(0),
											renderer: 'svg',
											loop: false,
											autoplay: true,
											assetsPath: '',
											path: $lottie.data('src')
										});
	
										secondaryAnimation.setSpeed($lottie.data('speed'));
										secondaryAnimation.goToAndStop(0, true); // Reset the animation to the first frame
	
										// console.log("Playing");
										secondaryAnimation.play(); // Start the animation
									});
								}
							}, delay);
	
							setTimeout(() => {
								if ($this.find('.hero__info').length) {
									$cursor.attr('data-color', '');
								}
							}, delay + 600);
						});
	
						$('.js-scalable').addClass('is-visible');
					});
				}
			});

			$container.data('lottie', animation);
			$container.addClass('lottie-loaded');

			playLottie($container, animation);
		});
	}

	/**
	 * Init hero panels.
	 */
	function initHeroPanels() {
		const $panels = $('.hero-panels').find('.js-lottie');

		$panels.each(function() {
			const $container = $(this);

			if($container.hasClass('lottie-loaded')) {
				return;
			}

			const animation = lottie.loadAnimation({
				container: $container.get(0),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				assetsPath: '',
				path: $container.data('src')
			});

			animation.setSpeed($container.data('speed'));

			animation.addEventListener('DOMLoaded', function() {
				const $firstPanel = $container.closest('.hero-panels').find('.gateway').first();
				const $secondPanel = $container.closest('.hero-panels').find('.gateway').last();

				const firstDelayTime = $firstPanel.find('[data-order-fade]').toArray().reduce((acc, el, index) => {
					return index == 1
						? acc + (parseFloat($(el).css('transition-duration')) * 1000)
						: acc + ((parseFloat($(el).css('transition-duration')) - (parseFloat($(el).css('--delay-timing')))) * 1000);
				}, 500);

				const secondDelayTile = $secondPanel.find('[data-order-fade]').toArray().reduce((acc, el, index) => {
					return index == 1
						? acc + (parseFloat($(el).css('transition-duration')) * 1000)
						: acc + ((parseFloat($(el).css('transition-duration')) - (parseFloat($(el).css('--delay-timing')))) * 1000);
				}, 0);

				$firstPanel.find('[data-order-fade]').addClass('is-visible');

				setTimeout(() => {
					animation.playSegments([0, 300], true);
				}, firstDelayTime - 1200);

				const animationDuration = (animation.getDuration(false) / $container.data('speed')) * 1000;

				setTimeout(() => {
					$secondPanel.find('[data-order-fade]').addClass('is-visible');
					// $firstPanel.removeClass('is-current');
					$secondPanel.addClass('is-current');
				}, firstDelayTime + (animationDuration / 2) - 1800);

				setTimeout(() => {
					// animation.playSegments([300, 600], true);
				}, firstDelayTime + (animationDuration / 2) + secondDelayTile + 1000);

				setTimeout(() => {
					// $firstPanel.addClass('is-set');
					// $secondPanel.addClass('is-set');
				}, firstDelayTime + animationDuration + secondDelayTile + 1200);

				$container.data('lottie', animation);
				$container.addClass('lottie-loaded');
			});
		});
	}

	/**
	 * Init section lotties.
	 */
	function initAutoplayLotties() {
		const $containers = $('.main section:not(.section-gateways.js-scroll-animation)')
			.find('.js-lottie')
			.filter(function() {
				return $(this).closest('.slider__clip').length < 1;
			});

		$containers.each(function() {
			const $container = $(this);
			const $section = $container.closest('section');
			const isInsideAnimatedFormSection = $section.hasClass('section-form') && $section.prev().hasClass('timeline');
			const windowTopOffset = isInsideAnimatedFormSection ? window_height() * 0.5 : 200;

			if($container.hasClass('lottie-loaded')) {
				return;
			}

			const animation = lottie.loadAnimation({
				container: $container.get(0),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				assetsPath: '',
				path: $container.data('src')
			});

			animation.setSpeed($container.data('speed'));

			animation.addEventListener('DOMLoaded', function() {
				$container.data('lottie', animation);
				$container.addClass('lottie-loaded');
				const offset = window_width() < 1024 ? 100 : -30;
				const winBottom = $win.scrollTop() + (window_height() - windowTopOffset);

				if (winBottom > $container.offset().top + offset && $container.offset().top != 0) {
					if(isInsideAnimatedFormSection) {
						setTimeout(() => {
							playLottie($container, animation);
						}, 1000);

						return;
					}

					playLottie($container, animation);
				}
			});

			$win.on('scroll', function() {
				const winBottom = $win.scrollTop() + (window_height() - windowTopOffset);
				const offset = window_width() < 1024 ? 100 : -30;

				if (winBottom > $container.offset().top + offset && $container.offset().top != 0) {
					if(isInsideAnimatedFormSection) {
						setTimeout(() => {
							playLottie($container, animation);
						}, 1000);

						return;
					}

					playLottie($container, animation);
				}
			});
		});
	}

	/**
	 * Play lottie.
	 * @param {jQuery} element
	 * @param {lottie.animation} animation
	 */
	function playLottie(element, animation) {
		if (!$(element).hasClass('lottie-played')) {
			$(element).addClass('lottie-played');

			setTimeout(() => {
				animation.play();
			}, 200);
		}
	}

	/**
	 * Initialize countUp animations.
	 * @returns {Void}
	 */
	function initCountUp() {
		const $countersContainer = $(".js-countup");
		const $counters = $(".js-countup .js-countup-number");
		const duration = 2;
		const startVal = 0;
		const separator = '.';

		$countersContainer.each(function () {
			$(this).find('.js-countup-number').each(function (index) {
				$(this).attr('data-index', index);
			});
		});

		if ($counters.length > 0) {
			$counters.each(function (index) {
				const finalValue = $(this).text();
				const decimalPlaces = getDecimalPlaces(finalValue, separator);
				const counterIndex = $(this).data('index') + 1;
				const isAnimatedSection = $(this).closest('section').hasClass('js-scroll-animation');
				const additionalOptions = isBreakpoint('tablet')
					? isAnimatedSection
						? {
							enableScrollSpy: false,
						}
						: {
							enableScrollSpy: true,
							scrollSpyDelay: counterIndex * 200,
							scrollSpyOnce: true,
						}
					: {
						enableScrollSpy: true,
						scrollSpyDelay: counterIndex * 200,
						scrollSpyOnce: true,
					};

				if (typeof finalValue === 'string' && !isNaN(finalValue)) {
					const countup = new CountUp(this, finalValue, $.extend({
							startVal: startVal,
							useIndianSeparators: true,
							duration: duration,
							decimalPlaces: decimalPlaces,
							separator: separator,
						}, additionalOptions)
					);

					$(this).data('counter', countup);
				}
			});
		}
	}

	/**
	 * Get number of decimal places in a number.
	 * @param {Number} number
	 * @param {String} separator
	 * @returns {Number}
	 */
	function getDecimalPlaces(number, separator) {
		const decimalPart = number.trim().toString().split(separator)[1];

		return decimalPart ? decimalPart.length : 0;
	}

	/**
	 * Initialize Plyr Videos.
	 */
	let nonAutoplayVideos = [];

	function initVideos() {
		const players = Array.from(document.querySelectorAll(".js-media-video"))

		players.map(function (p) {
			const isAutoplay = $(p).closest('.media__video').data('autoplay') == 1;
			const isInfinite = $(p).closest('.media__video').data('infinite') || isAutoplay;

			const player = new Plyr(p, {
				volume: 0,
				autoplay: isAutoplay,
				autopause: false,
				hideControls: true,
				controls: false,
				muted: true,
				loop: {
					active: isInfinite,
				}
			});

			if( !isAutoplay ) {
				nonAutoplayVideos.push(player);

				$(player.elements.container).siblings('.js-play-btn').on('click', function(event) {
					event.preventDefault();

					player.togglePlay();
					player.increaseVolume(50);
				});

				player.on('ended', () => {
					player.stop();
				})
			}

			if ( isAutoplay ) {
				$(player.elements.container).siblings('.js-play-btn').on('click', function(event) {
					event.preventDefault();

					player.play();
					$(player.elements.container).addClass('plyr--has-sound');
					player.increaseVolume(50);
				});
			}

			player.on('play', () => {
				$(player.elements.container).parent().addClass('is-played');

				if( !isAutoplay ) {
					nonAutoplayVideos.forEach(function(currentPlayer) {
						if(currentPlayer != player) {
							currentPlayer.pause();
							$(currentPlayer.elements.container).parent().removeClass('is-played');
						}
					});
				}
			});

			player.on('pause', () => {
				$(player.elements.container).parent().removeClass('is-played');
			});

			const playercontainer = p.parentNode;

			if (!p.parentNode) {
				//FOR: Reinit after ajax
				playercontainer = p;
			}

			const config = {
				rootMargin: '0px -100px',
				threshold: 0
			}

			const callback = (entries) => {
				entries.forEach((entry) => {
					if ( !entry.isIntersecting ) {
						player.pause();
						player.decreaseVolume(100);
					} else {
						if(isAutoplay) {
							player.play();
							player.decreaseVolume(100);
						}
						player.decreaseVolume(100);
					}
				});
			}

			player.on('ready', () => {
				player.decreaseVolume(1);
				let observer = new IntersectionObserver(callback, config);
				observer.observe(playercontainer);
			});
		});
	}

	/**
	 * Set font size variable relative to window aspect-ratio.
	 *
	 * @returns {Void}
	 */
	function setAspectRatioFontSize() {
		const contentMaxWidth = parseInt($('.shell:not(.shell--fluid)').first().css('max-width'));
		const contentWidth = Math.min(window_width(), contentMaxWidth);
		const fontWidthRatio = contentWidth*(10/contentMaxWidth);
		const fontPercent = Math.round(fontWidthRatio*100/16*100)/100;

		setCSSVariable('ar-font-size', fontPercent);
	}

	/**
	 * Fits the map viewport to the bounds of markers.
	 *
	 * @param {Object} map
	 * @param {Object} locations
	 * @returns {Void}
	 */
	function fitMapToBounds(map, locations) {
		const bounds = new window.google.maps.LatLngBounds();

		$.each(locations.locations, function(index, location){
			$.each(location.markers, function(index, marker) {
				bounds.extend({
					"lat": marker.lat,
					"lng": marker.long
				});
			});
		});

		map.fitBounds(bounds);
	}

	/**
	 * Create location filters markup from object with data.
	 *
	 * @param {Object} locations
	 * @returns {String}
	 */
	function createLocationFiltersMarkup(locations) {
		const $ul = $('<ul>');

		$.each(locations.locations, function(index, location) {
			if(!location.markers) {
				return;
			}

			const $li = $('<li>');
			const $a = $('<a>').attr('href', '#').text(location.name);

			setCSSVariable('marker-color', location.color, '', $li);

			if (location.isMainLocation) {
				$a.attr('data-main-location', location.isMainLocation);
			}

			$li.append($a);

			if (location.markers && location.markers.length > 0) {
				const $subUl = $('<ul>');

				$.each(location.markers, function(index, marker) {
					if(marker.lat !== "" && marker.long !== "") {
						const $subLi = $('<li>');
						const $subA = $('<a>').attr('href', '#').text(marker.name);
						$subLi.append($subA);
						$subUl.append($subLi);
					}
				});

				$li.append($subUl);
			}

			$ul.append($li);
		});

		return $ul;
	}

	/**
	 * Handle filters accordion.
	 */
	function toggleFiltersAccordion(target) {
		target.parent()
			.toggleClass('is-current')
		.siblings()
			.removeClass('is-current');

		target.siblings('ul')
			.stop()
			.slideToggle()
		.parent()
		.siblings()
		.find('ul')
			.stop()
			.slideUp();
	}

	/**
	 * Fetch JSON data from a file using AJAX.
	 *
	 * @param {String} filePath
	 * @returns {Promise}
	*/
	function loadAjax(filePath) {
		return new Promise(function (resolve, reject) {
			$.ajax({
				'url': filePath,
				'dataType': 'json',
				'async': true,
				'success': function (data) {
					resolve(data);
				},
				'error': function (jqXHR, textStatus, errorThrown) {
					reject('Error loading AJAX: ' + textStatus + ', ' + errorThrown);
				}
			});
		});
	}

	/**
	 * Create a google maps marker.
	 *
	 * @param {Object} map
	 * @param {Object} data
	 * @param {Number} scale
	 * @param {String} color
	 * @returns
	 */
	function createMarker(map, data, scale, color) {
		return new google.maps.Marker({
			position: new google.maps.LatLng(data.lat, data.long),
			map: map,
			title: data.name,
			is_main_location: data.isMainLocation,
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				scale: scale,
				fillColor: color,
				fillOpacity: 1,
				strokeWeight: 1,
				strokeColor: color,
			},
		});
	}

	/**
	 * Sets markers on the given map instance.
	 *
	 * @param {Object} map - instance of map
	 * @param {Array} markersData
	 * @returns {Array}
	 */
	function setMapMarkers(map, markersData) {
		const markers = [];

		$.each(markersData.locations, function(index, location){
			const color = location.color;

			if(location.isMainLocation == true) {
				const markerObj = createMarker(map, location, 17, color);
				markers.push(markerObj);
			}

			$.each(location.markers, function(index, marker) {
				const markerObj = createMarker(map, marker, 11, color);
				markers.push(markerObj);
			});
		});

		return markers;
	}

	/**
	 * Create an instance of google maps infoWindow.
	 *
	 * @param {Object} marker
	 * @returns {Object}
	 */
	function setInfoWindowContent(marker) {
		const isMainLocation = marker.is_main_location;
		const pixelOffsetX = isMainLocation ? 200 : 190;
		const pixelOffsetY = isMainLocation ? 43 : 38;

		const contentString = `
			<div class="map-marker">
				<h5>${marker.title}</h5>
			</div><!-- /.map-marker -->
		`;

		return new google.maps.InfoWindow({
			content: contentString,
			pixelOffset: new window.google.maps.Size(pixelOffsetX, pixelOffsetY)
		});
	}

	/**
	 * Pan Maps to a pin location with smooth animation.
	 *
	 * @param {google.maps.Map} map
	 * @param {google.maps.Marker} marker
	 * @param {Number} zoom
	 * @returns {Void}
	 */
	function animateMapToMarker(map, marker, zoom) {
		const cameraOptions = {
			tilt: 0,
			heading: 0,
			zoom: map.getZoom(),
			center: {
				lat: map.getCenter().lat(),
				lng: map.getCenter().lng()
			},
		};

		if((map.getCenter().lat() != marker.position.lat()) && (map.getCenter().lng() != marker.position.lng())) {
			new TWEEN.Tween(cameraOptions)
			.to({
				zoom: zoom,
				center: {
					lat: marker.position.lat(),
					lng: marker.position.lng(),
				}
			}, 600)
			.easing(TWEEN.Easing.Quadratic.Out)
			.onUpdate(() => {
					map.moveCamera(cameraOptions);
			})
			.start();

			function animate(time) {
				requestAnimationFrame(animate);
				TWEEN.update(time);
			}

			requestAnimationFrame(animate);
		}

	}

	/**
	 * Init map with filters.
	 *
	 * @returns {Void}
	 */
	function initFilteredMap() {
		if (!$('.map-alt').length) {
			return;
		}

		$('.map-alt').each(async function () {
			const $map = $(this);
			const mapMarkersUrl = $map.data('markers');
			const mapMarkersJSON = $map.data('markers-key') || false;
			const $filtersContainer = $map.closest('.js-map-alt').find('.js-map-filters');

			try {
				const centerLat = $map.data('lat');
				const centerLng = $map.data('lng');
				const zoom = $map.data('zoom');

				let mapData = {
					"mapOptions": {
						"center": {
							"lat": centerLat,
							"lng": centerLng
						},
						"zoom": zoom,
						"maxZoom": 17,
						zoomControl: false,
						fullscreenControl: false,
						mapTypeControl: false,
						streetViewControl: false,
						styles: [
							{
								"featureType": "all",
								"elementType": "labels.text",
								"stylers": [
									{
										"color": "#878787"
									}
								]
							},
							{
								"featureType": "all",
								"elementType": "labels.text.stroke",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "all",
								"stylers": [
									{
										"color": "#f9f5ed"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "all",
								"stylers": [
									{
										"color": "#f5f5f5"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"color": "#c9c9c9"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "all",
								"stylers": [
									{
										"color": "#aee0f4"
									}
								]
							},
							{
								"featureType": "poi.attraction",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.business",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.government",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.medical",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.school",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.place_of_worship",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.sports_complex",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "labels",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "transit.station",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#d0e1be"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "geometry.fill",
								"stylers": [
								  {
									"color": "#f2f2f2"
								  }
								]
							}
						]
					}
				}

				const map = new google.maps.Map($map.get(0), mapData.mapOptions);
				let infoWindow = new google.maps.InfoWindow({});

				if (!mapMarkersUrl && mapMarkersJSON == false) {
					return;
				}

				// Load Markers Data
				let mapMarkers = mapMarkersJSON && window.markersData[mapMarkersJSON] !== undefined ? 
					window.markersData[mapMarkersJSON] :
					await loadAjax(mapMarkersUrl);
				

				//Set Map Markers
				$map.markers = setMapMarkers(map, mapMarkers);

				//Create & Append Accordion Markup
				$filtersContainer.append(createLocationFiltersMarkup(mapMarkers));

				//Handlers
				function handleMarker(marker) {
					infoWindow.close();
					infoWindow = setInfoWindowContent(marker);
					infoWindow.open(map, marker);
				}

				$.each($map.markers, function (index, marker) {
					marker.addListener('click', function() {
						handleMarker(marker);
					});

					marker.addListener('mouseover', function() {
						handleMarker(marker);

						$filtersContainer.find('> ul > li li.is-current').removeClass('is-current');

						$filtersContainer.find('a')
							.filter((index, anchor) => marker.title == $(anchor).text())
							.first()
						.parent()
							.addClass('is-current');
					});

					marker.addListener('mouseout', function() {
						$filtersContainer.find('> ul > li li.is-current').removeClass('is-current');
						infoWindow.close();
					});
				});

				$filtersContainer.on('click', '> ul > li > a', function(event) {
					event.preventDefault();

					infoWindow.close();
					fitMapToBounds(map, mapMarkers);
					toggleFiltersAccordion($(this));
				});

				$filtersContainer.on('click', '> ul > li > ul a', function (event) {
					event.preventDefault();

					const marker = $map.markers.filter((marker) => marker.title == $(this).text())[0];

					infoWindow.close();
					infoWindow = setInfoWindowContent(marker);
					infoWindow.open(map, marker);

					animateMapToMarker(map, marker, 16);

					$filtersContainer.find('> ul > li li.is-current').removeClass('is-current');
					$(this).parent().toggleClass('is-current');
				});

				$filtersContainer.on('mouseover', '> ul > li > ul a', function () {
					const marker = $map.markers.filter((marker) => marker.title == $(this).text())[0];

					infoWindow.close();
					infoWindow = setInfoWindowContent(marker);
					infoWindow.open(map, marker);

					$filtersContainer.find('> ul > li li.is-current').removeClass('is-current');
				}).on('mouseleave', '> ul > li > ul a', function() {
					if(!$(this).parent().hasClass('is-current')) {
						infoWindow.close();
					}
				});
			} catch (error) {
				console.error(error);
			}
		});
	}

	/**
	 * Initialize zoomable custom map.
	 *
	 * @returns {Void}
	 */
	function initZoomist() {
		if($('.zoomist-container').length == 0) {
			return;
		}

		$('.zoomist-container').each(function () {
			new Zoomist($(this).get(0), {
				maxScale: 4,
				bounds: window_width() <= 1023,
				zoomer: true,
				wheelable: false,
				zoomRatio: 0.3,
			});
		});

		$('.js-masterplan map').imageMapResize();

		$('.js-masterplan .map__zoom').on('click', function(event) {
			event.preventDefault();

			const elevateZoom = $('.js-masterplan img').data('elevateZoom');
			elevateZoom.zoomIn();
		});

		$('.js-masterplan .map__out').on('click', function(event) {
			event.preventDefault();

			const elevateZoom = $('.js-masterplan img').data('elevateZoom');
			elevateZoom.zoomOut();
		});

		$('.map-masterplan[data-hover] area').on('mouseover', function() {
			if(!isBreakpoint('tablet', false)) {
				return;
			}

			const index = parseInt($(this).data('target'));
			const $uniqueAreas = [...new Set($('map[name="map-image_map"] area').map((index, element) => $(element).data('target')).get())];
			const backgroundPositionY = (index * (100 / $uniqueAreas.length)) + '%';

			$('.map-masterplan .zoomist-image').css('background-position-y', backgroundPositionY);
		}).on('mouseleave', function() {
			if(!isBreakpoint('tablet', false)) {
				return;
			}

			$('.map-masterplan .zoomist-image').css('background-position-y', '');
		});

		$('.map-masterplan .map__filters a').on('click', function(event) {
			event.preventDefault();

			const index = parseInt($(this).data('target'));
			const $uniqueAreas = [...new Set($('map[name="map-image_map"] area').map((index, element) => $(element).data('target')).get())];
			const backgroundPositionY = (index * (100 / $uniqueAreas.length)) + '%';

			$(this).parent()
				.addClass('is-current')
			.siblings()
				.removeClass('is-current');

			$('.map-masterplan .zoomist-image').css('background-position-y', backgroundPositionY);
		});

		$doc.on('mouseover', '.zoomist-zoomer-in, .zoomist-zoomer-out', function() {
			$('.zoomist-image').css('transition', 'transform .25s');
		}).on('mouseleave', '.zoomist-zoomer-in, .zoomist-zoomer-out', function() {
			$('.zoomist-image').css('transition', '');
		});
	}


	/**
	 * Init Google Maps.
	 *
	 * @returns {Void}
	 */
	function initMap() {
		if (!$('.map').length) {
			return;
		}

		$('.map').each(async function () {
			const $map = $(this);
			const mapMarkersUrl = $map.data('markers');
			const mapMarkersJSON = $map.data('markers-key') || false;

			try {
				const centerLat = $map.data('lat');
				const centerLng = $map.data('lng');
				const zoom = $map.data('zoom');

				let mapData = {
					"mapOptions": {
						"center": {
							"lat": centerLat,
							"lng": centerLng
						},
						"zoom": zoom,
						"maxZoom": 17,
						zoomControl: false,
						fullscreenControl: false,
						mapTypeControl: false,
						streetViewControl: false,
						styles: [
							{
								"featureType": "water",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#e9e9e9"
									},
									{
										"lightness": 17
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f5f5f5"
									},
									{
										"lightness": 20
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 17
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 29
									},
									{
										"weight": 0.2
									}
								]
							},
							{
								"featureType": "road.arterial",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 18
									}
								]
							},
							{
								"featureType": "road.local",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 16
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f5f5f5"
									},
									{
										"lightness": 21
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#dedede"
									},
									{
										"lightness": 21
									}
								]
							},
							{
								"elementType": "labels.text.stroke",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#ffffff"
									},
									{
										"lightness": 16
									}
								]
							},
							{
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"saturation": 36
									},
									{
										"color": "#333333"
									},
									{
										"lightness": 40
									}
								]
							},
							{
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "transit",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f2f2f2"
									},
									{
										"lightness": 19
									}
								]
							},
							{
								"featureType": "administrative",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#fefefe"
									},
									{
										"lightness": 20
									}
								]
							},
							{
								"featureType": "administrative",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"color": "#fefefe"
									},
									{
										"lightness": 17
									},
									{
										"weight": 1.2
									}
								]
							}
						],
					}
				}

				const map = new google.maps.Map($map.get(0), mapData.mapOptions);

				if (!mapMarkersUrl) {
					return;
				}

				// Load Markers Data
				let mapMarkers = mapMarkersJSON && window.markersData[mapMarkersJSON] !== undefined ? 
					window.markersData[mapMarkersJSON] :
					await loadAjax(mapMarkersUrl);

				console.log(mapMarkers);

				const mainLocations = mapMarkers.locations.filter((location) => location.isMainLocation == true);

				$.each(mainLocations, function (index, marker) {
					const opacity = {
						value: $map.closest('.hero-intro').length > 0
							? getElementInnerScrollProgress('.hero-intro') >= 0.97
								? 1
								: 0
							: 1
					}

					let markerObj = new window.google.maps.Marker({
						position: new google.maps.LatLng(marker.lat, marker.long),
						map: map,
						opacity: opacity.value,
						icon: {
							url: main_theme.template_url + marker.icon,
						}
					});

					$win.on('scroll', function() {
						gsap.to(opacity, {
							duration: .6,
							value: $map.closest('.hero-intro').length > 0
								? getElementInnerScrollProgress('.hero-intro') >= 0.97
									? 1
									: 0
								: 1,
							onUpdate() {
								markerObj.setOpacity(opacity.value);
							}
						});
					});
				});
			} catch (error) {
				console.error(error);
			}
		});
	}

	/**
	 * Init Stats section scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initStatsScrollAnimation(container) {
		const $container = $(container);
		const $titleItems = $container.find('.section__title span');
		const $mediaItem = $container.find('.section__media');
		const $statsItems = $container.find('.stats li a');

		//Handle transform data update.
		$win.on('resize', function(e) {
			if ($win.width() < 1024) {
				return;
			}

			$titleItems.each(function() {
				setTransformData($(this), true);
			});

			$statsItems.each(function() {
				setTransformData($(this), true);
			});

			setTransformData($mediaItem, true);
		});

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				//Set transform data.
				$titleItems.each(function() {
					setTransformData($(this), true);
				});

				$statsItems.each(function() {
					setTransformData($(this), true);
				});

				setTransformData($mediaItem, true);

				//Create timeline + pin spacer.
				const statsTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $container.get(0),
						start: () => `top top`,
						end: () => `+=300%`,
						pin: true,
						scrub: true,
						onLeaveBack: () => {
							const $prevSection = $container.parent().prev();

							if ($prevSection.children().first().hasClass('section-gateway js-scroll-animation') && isNormalScroll != false) {
								$win.scrollTop($prevSection.offset().top + $prevSection.outerHeight() - window_height());
							}
						}
					}
				});

				$(statsTimeline.scrollTrigger.spacer).css('background-color', $container.css('background-color'));

				//Title position update.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: 'top top',
					end: '30% 30%',
					scrub: true,
					onUpdate: self => {
						$titleItems.each(function() {
							const transformData = $(this).data('transform');

							$(this).css('transform', `translate3d(${calculateInterpolateValue(transformData.x, 0, self.progress)}px, 0, 0)`);
						});

						$container.find('.section__intro').toggleClass('is-visible', self.progress >= 1);
					}
				});

				//Media position update.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '30% 30%',
					end: '60% 60%',
					scrub: true,
					onUpdate: self => {
						const mediaTransformX = $mediaItem.data('transform').x;

						$mediaItem.css('transform', `translate3d(${calculateInterpolateValue(mediaTransformX, 0, self.progress)}px, 0, 0)`);

						$container.find('.section__entry').toggleClass('is-visible', self.progress >= 1);
					}
				});

				//Stats numbers animation.
				const $stats = $container.find('.stats li');
				const progressPerStat = 40 / $stats.length;
				let positionStart = 60;

				$stats.each(function () {
					const $this = $(this);

					$this.data('isCountUpStarted', false);

					ScrollTrigger.create({
						trigger: $container.parent().get(0),
						start: `${positionStart}% ${positionStart}%`,
						end: `${positionStart + progressPerStat}% ${positionStart + progressPerStat}%`,
						scrub: true,
						onUpdate: self => {
							$this.find('.stats__line').css('height', `${calculateInterpolateValue(0, 100, self.progress)}%`);

							$this.find('h4').toggleClass('is-visible', self.progress >= 0.4);
							$this.find('h3').toggleClass('is-visible', self.progress >= 0.8);

							if(self.progress >= 0.8 && $this.data('isCountUpStarted') === false) {
								setTimeout(() => {
									$this.find('.js-countup-number').data('counter').start();
								}, 200);

								$this.data('isCountUpStarted', false);
							}

							const statTransformData = $(this).find('> a').data('transform');
							$(this).find('> a').css('transform', `translate(0, ${self.progress >= 0.35 ? 0 : statTransformData.y}px)`);
						}
					});

					positionStart += progressPerStat * 0.5;
				});
			}
		});
	}

	/**
	 * Init Gateways scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initGatewaysScrollAnimation(container) {
		const $container = $(container);
		const useFourSlides = $container.hasClass("section-gateway--four");
		const $slider = $container.find('.slider__slides');
		const $gatewaySlides = $container.find('.slider__slide');
		const $sliderButton = $container.find('.slider__next');
		const extendMultiplier = 0.1;
		const animationObjects = [];
		const isBeforeStatsSection = $container.next().hasClass('section-stats') && $container.next().hasClass('js-scroll-animation');

		$container.toggleClass('is-default', !isBeforeStatsSection);

		let currentClosestSlideIndex = 0;

		function getSingleSliderCSSWidth() {
			return parseFloat($gatewaySlides.first().css('--percent-width'));
		}

		function getGatewaysEndPosition() {
			const multiplier = Math.floor(parseFloat(window_width() / $gatewaySlides.first().outerWidth()));

			return getSingleSliderCSSWidth() * multiplier - (100 - ($gatewaySlides.first().outerWidth() * multiplier * 100) / window_width());
		}

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				$slider.find('.js-lottie').each(function(i) {
					const $container = $(this);

					if ($container.hasClass('lottie-loaded')) {
						$container.data('lottie').destroy();
						$container.removeClass('lottie-loaded');
					}

					const animation = lottie.loadAnimation({
						container: $container.get(0),
						renderer: 'svg',
						loop: false,
						autoplay: false,
						assetsPath: '',
						path: $container.data('src')
					});

					animation.setSpeed($container.data('speed'));

					$container.data('lottie', animation);
					$container.addClass('lottie-loaded');
					animationObjects.push(animation);
				});

				//Add pin spacer.
				ScrollTrigger.create({
					trigger: $container.get(0),
					start: () => 'top top',
					end: () => `+=${useFourSlides
						? `${$gatewaySlides.first().outerWidth() * ($gatewaySlides.length + (1 + extendMultiplier))}px`
						: `${$gatewaySlides.first().outerHeight() * $gatewaySlides.length}px`}`,
					pin: true,
					scrub: true
				});

				//Horizontal scroll animation.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: 'top top',
					end: `${useFourSlides
						? `${getGatewaysEndPosition() * (1 - extendMultiplier)}%`
						: `bottom`
					} bottom`,
					scrub: true,
					onUpdate: (self) => {
						if(useFourSlides) {
							$gatewaySlides.parent()
								.css('transform', `translate3d(${self.progress  * (getSingleSliderCSSWidth() * 2 - (100 - ($gatewaySlides.first().find('.gateway').outerWidth() * 2 * 100)/window_width())) * -1}%, 0, 0)`);
						} else {
							$gatewaySlides.parent()
								.css('transform', `translate3d(${self.progress  * (getSingleSliderCSSWidth() * 2 - (100 - ($gatewaySlides.first().find('.gateway').outerWidth() * 100)/window_width())) * -1}%, 0, 0)`);
						}
					}
				});

				//Circle Expand.
				if(isBeforeStatsSection) {
					ScrollTrigger.create({
						trigger: $container.parent().get(0),
						start: `${getGatewaysEndPosition() * (1 - extendMultiplier)}% ${getGatewaysEndPosition() * (1 - extendMultiplier)}%`,
						end: 'bottom bottom',
						scrub: true,
						onUpdate: (self) => {
							const circleScale = window_height() >= window_width()
								? calculateInterpolateValue(0, window_height() * 2.5, self.progress)
								: calculateInterpolateValue(0, window_width() * 2.5, self.progress);

							$container.css('--scale', `${circleScale}px`);

							$sliderButton.css('opacity', self.progress >= 0.01 ? 0 : '');
						},
						onLeave: () => {
							if(isNormalScroll != false) {
								$win.scrollTop($container.parent().next().offset().top);
							}
						}
					});
				}

				//Lottie animations
				const numSlides = $gatewaySlides.length;
				const numAnimations = animationObjects.length;

				function updateLottieAnimation(self) {
					const progressPerSlide = 1 / numSlides;

					const slideIndex = Math.min(Math.floor(self.progress / progressPerSlide), numAnimations - 1);
					currentClosestSlideIndex = slideIndex;

					const slideProgress = (self.progress - slideIndex * progressPerSlide) / progressPerSlide;

					const currentLottie = animationObjects[slideIndex];

					const frame = Math.min(slideProgress * currentLottie.totalFrames, currentLottie.totalFrames);

					for (let i = 0; i < slideIndex; i++) {
						animationObjects[i].goToAndStop(animationObjects[i].totalFrames, true);
					}

					for (let i = slideIndex + 1; i < animationObjects.length; i++) {
						animationObjects[i].goToAndStop(0, true);
					}

					currentLottie.goToAndStop(frame, true);
				};

				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: `-=400px`,
					end: () => `+=${isBeforeStatsSection
						? `${$gatewaySlides.first().outerWidth() * ($gatewaySlides.length + (1 + extendMultiplier))}px`
						: `${$gatewaySlides.first().outerHeight() * $gatewaySlides.length}px`
					}`,
					scrub: true,
					onUpdate: updateLottieAnimation
				});

				$sliderButton.on('click', function(event) {
					if(window_width() >= 1024) {
						const baseScrollTop = $container.parent().offset().top;
						const slideWidth = $gatewaySlides.first().outerWidth();
						const slideHeight = $gatewaySlides.first().outerHeight();
						const slideIndex = Math.min(currentClosestSlideIndex + 1, $gatewaySlides.length - 2);
						const containerHeight = $container.parent().outerHeight();
						const totalSlides = $gatewaySlides.length;
						const additionalScroll = isBeforeStatsSection
							? currentClosestSlideIndex + 2 >= totalSlides
								? slideWidth * totalSlides
								: (((containerHeight - (slideWidth * (1 + extendMultiplier)))) / totalSlides) * (currentClosestSlideIndex + 1) - (400 + (8 * slideIndex))
							: currentClosestSlideIndex + 2 >= totalSlides
								? slideHeight * totalSlides
								: ((slideHeight + 1) * (currentClosestSlideIndex + 1) - 400);

						$('html, body').animate({
							scrollTop: baseScrollTop + additionalScroll
						}, 1000);

						$('html, body').one('mousewheel', function() {
							$(this).stop();
						})
					}
				});
			}
		});
	}

	/**
	 * Init Accordion scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initAccordionScrollAnimation(container) {
		const $container = $(container);
		const $title = $container.find('.section__aside > h2');
		const $accordion = $container.find('.js-accordion');

		//Handle transform data update.
		$win.on('resize', function(e) {
			if ($win.width() < 1024) {
				return;
			}

			setTransformData($title, true);
		});

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				//Set transform data.
				setTransformData($title, true);

				//Create timeline + pin spacer.
				const accordionTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $container.get(0),
						start: () => `top top`,
						end: () => `+=270%`,
						pin: true,
						scrub: true,
						onRefresh: () => {
							$(accordionTimeline.scrollTrigger.spacer).css('z-index', 2);
						}
					}
				});

				$(accordionTimeline.scrollTrigger.spacer).css('background-color', $container.css('background-color'));
				$(accordionTimeline.scrollTrigger.spacer).css('z-index', 2);

				//Title position update.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '-30% -30%',
					end: `20% 20%`,
					scrub: true,
					onUpdate: self => {
						$title.each(function() {
							const transformData = $(this).data('transform');

							$(this).css('transform', `translate3d(${calculateInterpolateValue(transformData.x, 0, self.progress)}px, 0, 0)`);
						});
					}
				});

				//First accordion fade toggle.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '20% 20%',
					end: '60% 60%',
					scrub: true,
					onUpdate: self => {
						$accordion.find('.accordion__section:first-child').toggleClass('is-set', self.progress >= 0.75);
						$accordion.find('.accordion__section').toggleClass('is-visible', self.progress >= 1);
					}
				});

				//Text fade toggle.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '60% 60%',
					end: '80% 80%',
					scrub: true,
					onUpdate: self => {
						$container.find('.section__entry').toggleClass('is-visible', self.progress >= 1);
					}
				});
			}
		});
	}

	/**
	 * Init Text Slider section scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initTextSliderScrollAnimation(container) {
		const $container = $(container);
		const $titleItems = $container.find('.section__head h2 span');
		const $contentItems = $container.find('.section__entry, .slider__slides');
		const $sliderDots = $container.find('.slick__dots');

		//Handle transform data update.
		$win.on('resize', function(e) {
			if ($win.width() < 1024) {
				return;
			}

			$titleItems.each(function() {
				setTransformData($(this), true);
			});

			$contentItems.each(function() {
				setTransformData($(this), true);
			});

			setTransformData($sliderDots, true);
		});

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				//Set transform data.
				$titleItems.each(function() {
					setTransformData($(this), true);
				});

				$contentItems.each(function() {
					setTransformData($(this), true);
				});

				setTransformData($sliderDots, true);

				//Create timeline + pin spacer.
				const animationTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $container.get(0),
						start: () => `top top`,
						end: () => `+=300%`,
						pin: true,
						scrub: true,
					}
				});

				$(animationTimeline.scrollTrigger.spacer).css('background-color', $container.css('background-color'));

				//Title position update.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '-20% -20%',
					end: '30% 30%',
					scrub: true,
					onUpdate: self => {
						$titleItems.each(function() {
							const transformData = $(this).data('transform');

							$(this).css('transform', `translate3d(${calculateInterpolateValue(transformData.x, 0, self.progress)}px, 0, 0)`);
						});
					}
				});

				//Media position update.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '30% 30%',
					end: '60% 60%',
					scrub: true,
					onUpdate: self => {
						$container.css('--line-width', `${self.progress * 100}%`);
						$container.find('.slider-media .slick-dots').toggleClass('is-visible', self.progress >= 1);

						if(self.progress >= 1) {
							$container.find('.js-slider-media--autoplay .slider__slides').slick('slickPlay');
						}
					}
				});

				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '60% 60%',
					end: '90% 90%',
					scrub: true,
					onUpdate: self => {
						$contentItems.each(function() {
							const transformData = $(this).data('transform');

							$(this).css('transform', `translate3d(${calculateInterpolateValue(transformData.x, 0, self.progress)}px, 0, 0)`);
						});

						$container.find('.slider__next').toggleClass('is-visible', self.progress >= 0.7);
					}
				});
			}
		});
	}

	/**
	 * Init Projects scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initProjectsScrollAnimation(container) {
		const $container = $(container);
		const $contentItems = $container.find('.section__entry, .slick-dots');
		const $contentMedia = $container.find('.slider-media .media-wrapper');
		const $contentNav = $container.find('.section__nav');

		//Create timeline + pin spacer.
		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				const animationTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $container.get(0),
						start: () => `top top`,
						end: () => `+=300%`,
						pin: true,
						scrub: true,
					}
				});

				$(animationTimeline.scrollTrigger.spacer).css('background-color', $container.css('background-color'));

				//Reveal Content + border.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '-20% -20%',
					end: '30% 30%',
					scrub: true,
					onUpdate: (self) => {
						$container.css('--line-width', `${self.progress * 100}%`);

						$contentItems.toggleClass('is-visible', self.progress >= 0.7);
					}
				});

				//Reveal media.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '35% 35%',
					end: '65% 65%',
					scrub: true,
					onUpdate: (self) => {
						$contentMedia.css('clip-path', `inset(0 0 0 ${100 - (self.progress * 100)}%)`);
					}
				});

				//Reveal nav items.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: '45% 45%',
					end: '90% 90%',
					scrub: true,
					onUpdate: (self) => {
						$contentNav.find('li:first-child').toggleClass('is-visible', self.progress >= 0.4);
						$contentNav.find('li:not(:first-child)').toggleClass('is-visible', self.progress >= 0.7);
					}
				});
			}
		});
	}

	/**
	 * Init Media-slider scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initMediaSliderScrollAnimation(container) {
		const $container = $(container);
		const $slideImages = $container.find('.media-wrapper picture');
		const $sliderHeader = $container.find('.slider__inner');
		const $sliderDots = $container.find('.slick-dots');
		const $sliderInfo = $container.find('.slider__info');

		setCSSVariable('slider-head-height', $sliderHeader.outerHeight(), 'px', $container);
		setCSSVariable('image-offset', (window_height()-$sliderHeader.outerHeight()) * 0.22, 'px', $container);

		$win.on('resize', function(event) {
			setCSSVariable('slider-head-height', $sliderHeader.outerHeight(), 'px', $container);
			setCSSVariable('image-offset', (window_height()-$sliderHeader.outerHeight()) * 0.22, 'px', $container);
		});

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				const animationTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $container.get(0),
						start: () => `top top`,
						end: () => `+=100%`,
						pin: true,
						scrub: true,
						onUpdate: self => {
							$sliderInfo.toggleClass('is-visible', self.progress >= 0.6);
							$sliderDots.toggleClass('is-visible', self.progress >= 0.8);
							$container.toggleClass('clickable', self.progress >= 0.8);
						}
					}
				})
				.to($container.find('.slider__clip'), {
					y: 0,
					scrollTrigger: {
						trigger: $container.parent().get(0),
						start: () => `30% 30%`,
						end: '80% 80%',
						scrub: true,
						onUpdate: self => {
							$container.css('--line-width', `${self.progress * 100}%`);
						}
					}
				})
				.to($slideImages, {
					height: '100%',
					width: '100%',
					scrollTrigger: {
						trigger: $container.parent().get(0),
						start: 'top top',
						end: '70% 70%',
						scrub: true,
					}
				}, '<');

				$(animationTimeline.scrollTrigger.spacer).css('pointer-events', 'none');
			}
		});
	}

	/**
	 * Init features slider scroll animation.
	 *
	 * @param {jQuery} container
	 */
	function initFeaturesSliderScrollAnimation(container) {
		const $container = $(container);
		const $slider = $container.find('.slider__slides');
		const $featureSlides = $container.find('.slider__slide');
		const $sliderButton = $container.find('.slider__next');
		const animationObjects = [];

		let currentClosestSlideIndex = 0;
		let previousSlideIndex = -1; // Track the previous slide index to prevent unnecessary resets

		function getSingleSliderCSSWidth() {
			return parseFloat($featureSlides.first().css('--percent-width'));
		}

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				$slider.find('.js-lottie').each(function(i) {
					const $container = $(this);

					if ($container.hasClass('lottie-loaded')) {
						$container.data('lottie').destroy();
						$container.removeClass('lottie-loaded');
					}

					const animation = lottie.loadAnimation({
						container: $container.get(0),
						renderer: 'svg',
						loop: false,
						autoplay: false,
						assetsPath: '',
						path: $container.data('src'),
						rendererSettings: {
							preserveAspectRatio: 'xMidYMid slice',
							progressiveLoad: false,
							hideOnTransparent: false
						}
					});

					animation.setSpeed($container.data('speed'));

					$container.data('lottie', animation);
					$container.addClass('lottie-loaded');
					animationObjects.push(animation);
				});

				//Add pin spacer.
				ScrollTrigger.create({
					trigger: $container.get(0),
					start: () => 'top top',
					end: () => `+=${$featureSlides.first().outerWidth() * $featureSlides.length}px`,
					pin: true,
					scrub: true
				});

				//Horizontal scroll animation.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: 'top top',
					end: `bottom bottom`,
					scrub: true,
					onUpdate: (self) => {
						const slideWidth = $featureSlides.first().outerWidth();

						$featureSlides.parent()
								.css('transform', `translate3d(${self.progress * (getSingleSliderCSSWidth() * ($featureSlides.length - 1) - (100 - (slideWidth * 100)/window_width())) * -1}%, 0, 0)`);
					}
				});

				//Lottie animations
				const numSlides = $featureSlides.length;
				const numAnimations = animationObjects.length;

				// Cache for animation states to prevent unnecessary updates
				const animationStates = new Array(animationObjects.length).fill(false);
				
				function updateLottieAnimation(self) {
					const progressPerSlide = 1 / (numSlides / 1.9);
					const slideIndex = Math.min(Math.floor(self.progress / progressPerSlide), numAnimations - 1);
					
					// Get the slide progress (from 0 to 1) within the current slide
					const slideProgress = (self.progress - slideIndex * progressPerSlide) / progressPerSlide;
					
					// Mark animations that need updating
					if (slideIndex !== previousSlideIndex) {
						// If we've moved forward
						if (slideIndex > previousSlideIndex) {
							// Only complete animations we haven't completed yet
							for (let i = 0; i <= slideIndex - 1; i++) {
								if (i < animationObjects.length && !animationStates[i]) {
									// Set to completed state and mark as done
									animationObjects[i].goToAndStop(animationObjects[i].totalFrames - 1, true);
									animationStates[i] = true;
								}
							}
						} 
						// If we've moved backward
						else if (slideIndex < previousSlideIndex) {
							// Reset animations we've moved past
							for (let i = previousSlideIndex; i > slideIndex; i--) {
								if (i < animationObjects.length) {
									animationObjects[i].goToAndStop(0, true);
									animationStates[i] = false;
								}
							}
						}
						
						previousSlideIndex = slideIndex;
					}
					
					// Always update the current animation
					const currentLottie = animationObjects[slideIndex];
					if (currentLottie) {
						// Ensure we're not exceeding frame bounds
						const totalFrames = currentLottie.totalFrames || 300; // Fallback if totalFrames isn't available
						const frame = Math.floor(Math.min(slideProgress * totalFrames, totalFrames - 1));
						
						// Only update if the frame has changed or if we're on the active animation
						// This prevents unnecessary resets
						currentLottie.goToAndStop(frame, true);
						
						// If we're close to the end, mark as completed
						animationStates[slideIndex] = frame >= totalFrames - 5;
					}
					
					currentClosestSlideIndex = slideIndex;
				};

				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: `-=${$featureSlides.first().outerWidth()/2}px`,
					end: () => `bottom bottom`,
					scrub: true,
					onUpdate: updateLottieAnimation
				});

				const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

				const calculateValueBasedOnWidth = () => {
					const width1 = 1024;
					const value1 = 8;
					const width2 = 1728;
					const value2 = 14;

					const adjustedWindowWidth = $win.outerWidth() - getScrollbarWidth() < width1
						? width1
						: $win.outerWidth() - getScrollbarWidth();

					const slope = (value2 - value1) / (width2 - width1);

					return value1 + slope * (adjustedWindowWidth - width1);
				}

				$sliderButton.on('click', function(event) {
					if(window_width() >= 1024) {
						const baseScrollTop = $container.parent().offset().top;
						const slideWidth = $featureSlides.first().outerWidth() * 2;
						const totalSlides = $featureSlides.length;
						const slideIndex = Math.min(currentClosestSlideIndex + 2, $featureSlides.length - 4);
						const additionalScroll = currentClosestSlideIndex + 6 >= totalSlides
								? slideWidth * (totalSlides / 2)
								: ((slideWidth + 1) * (currentClosestSlideIndex + 2) - ($featureSlides.first().outerWidth() / 1.9)) + (calculateValueBasedOnWidth() * slideIndex);

						$('html, body').animate({
							scrollTop: baseScrollTop + additionalScroll
						}, 1000);

						$('html, body').one('mousewheel', function() {
							$(this).stop();
						})
					}
				});
			}
		});
	}

	/**
	 * Percentage to pixel convert.
	 *
	 * @param {jQuery} element
	 * @param {Number} percentage
	 * @returns {Number}
	 */
	function percentToPixel(element, percentage){
		return (element.parent().outerWidth() / 100) * parseFloat(percentage);
	}


	/**
	 * Get shell offset.
	 *
	 * @returns {Number}
	 */
	function getShellOffset() {
		const $shell = $doc.find('.shell:not(.shell--fluid)').first();

		return window_width() > $shell.outerWidth()
			? (window_width() - $shell.outerWidth()) / 2
			: parseFloat($shell.css('padding-left'));
	}

	/**
	 * Check if device has touch.
	 *
	 * @returns {Boolean}
	 */
	function isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	}

	/**
	 * Breakpoint checker.
	 *
	 * @param {String} deviceType
	 * @param {Boolean} isBelow
	 * @returns {Boolean}
	 */
	function isBreakpoint(deviceType, isBelow) {
		const map = {
			'tablet' : 1023,
			'mobile' : 767,
		}

		return isBelow
			? window_width() <= map[deviceType]
			: window_width() > map[deviceType];
	}

	/**
	 * Toggle Accordion.
	 *
	 * @param {jQuery} target
	 */

	let refreshTimeout;
	let refreshInterval;

	function toggleAccordion(target) {
		const $this = $(target).closest('.accordion__section');
		const $pinSpacer = $this.closest('.pin-spacer');

		$this.toggleClass('is-current')
			.find('.accordion__body')
				.stop()
				.slideToggle(400);

		$this.siblings()
			.removeClass('is-current')
		.find('.accordion__body')
			.stop()
			.slideUp(400);

		// clearTimeout(refreshTimeout);

		refreshInterval = setInterval(() => {
			ScrollTrigger.refresh(true);
		}, 10);

		refreshTimeout = setTimeout(() => {
			clearInterval(refreshInterval);
		}, 400);
	}

	/**
	 * Expand Inner Circle Animation.
	 *
	 * @param {Number} duration
	 * @param {Number} targetRadius
	 * @param {Function} onComplete
	 *
	 * @return {Void}
	 */
	function expandInnerCircle(duration, targetRadius) {
		gsap.to(innerCircleProperties, {
			duration: duration,
			vectorZ: -1,
			radius: targetRadius,
			onUpdate: function() {
				circle.material.uniforms.innerRadius.value = innerCircleProperties.radius;
			},
			onComplete: function () {
				outerCircleProperties.radius = .1;
				outerCircleProperties.vectorZ = 1;
				outerCircleProperties.geometry = 0.1;
				innerCircleProperties.radius = .01;
				innerCircleProperties.vectorZ = 1;
				circle.material.uniforms.innerRadius.value = 0;

				geometry.dispose();
				geometry = new THREE.CircleGeometry(.1, 128);
				circle.geometry.dispose();
				circle.geometry = geometry;

				updateCirclePosition();

				$win.bind('mousemove', updateCirclePosition);
				$externalLinks.css('pointer-events', '');
				$cursor.removeClass('is-new-page');
			}
		});
	}

	/**
	 * Expand Outer Circle Animation.
	 *
	 * @param {Number} duration
	 * @param {Number} targetRadius
	 * @param {Number} targetGeometry
	 * @param {Boolean} isSequence
	 * @param {Number} timeout
	 *
	 * @returns {Void}
	 */
	function expandOuterCircle(duration, targetRadius, targetGeometry, isSequence = false, timeout = 0) {
		const currentMouseX = (isSequence && getCursorCoordinatesFromCookie()) ? getCursorCoordinatesFromCookie().x : getMouseX();
		const currentMouseY = (isSequence && getCursorCoordinatesFromCookie()) ? getCursorCoordinatesFromCookie().y : getMouseY();

		$win.unbind('mousemove', updateCirclePosition);

		if(isSequence) {
			$externalLinks.css('pointer-events', 'none');
		}

		gsap.to(outerCircleProperties, {
			duration: duration,
			vectorZ: -1,
			radius: targetRadius,
			geometry: targetGeometry,
			onUpdate: () => {
				const vector = new THREE.Vector3(currentMouseX, currentMouseY, outerCircleProperties.vectorZ);
				vector.unproject(camera);

				circle.position.copy(vector);

				geometry.parameters.radius = outerCircleProperties.geometry;
				geometry.dispose();
				geometry = new THREE.CircleGeometry(outerCircleProperties.geometry, 128);
				circle.geometry.dispose();
				circle.geometry = geometry;
			},
			onComplete: () => {
				if(isSequence) {
					$('body').addClass('is-loaded');

					setTimeout(() => {
						expandInnerCircle(1.5, 0.43);
					}, timeout);
				} else {
					$('body').removeClass('is-loaded');
				}
			}
		});
	}

	/**
	 * Set temporary cookie.
	 *
	 * @param {String} name
	 * @param {Object} value
	 *
	 * @returns {Void}
	 */
	function setTempCookie(name, value) {
		document.cookie = name + "=" + value + ";" + ";path=/";
	}

	/**
	 * Get cursor coordinates from cookie.
	 * @returns
	 */
	function getCursorCoordinatesFromCookie() {
		const decodedCookie = decodeURIComponent(document.cookie);
		const cookieArray = decodedCookie.split(';');
		let cursorCoordinates = null;

		cookieArray.forEach(cookie => {
			const [name, value] = cookie.split('=');
			if (name.trim() === 'cursorCoordinates') {
				cursorCoordinates = JSON.parse(value);
			}
		});

		return cursorCoordinates;
	}

	/**
	 *
	 * INIT && HANDLERS
	 *
	 */

	/**
	 * Initialize selectric plugin on a set of elements
	 * @param {Object} element
	 * @returns {Void}
	 */
	function initSelectric(element) {
		if ( !$(element).length || !$(element).is('select') ) {
			return;
		}

		$(element).selectric({
			disableOnMobile: false,
			nativeOnMobile: false,
			onOpen: function() {
				$(".selectric-input").blur();
				const $wrp = $(this).closest('.selectric-wrapper');
				const $fixer = $wrp.find('.selectric-items');

				$fixer.fadeOut();
				$fixer.stop(true, true).hide().fadeIn();
			},
			onClose: function() {
				const $wrp = $(this).closest('.selectric-wrapper');
				const $fixer = $wrp.find('.selectric-items');

				$fixer.fadeIn();
				$fixer.stop(true, true).show().fadeOut();
			},
			onChange: function() {
				const $wrp = $(this).closest('.selectric-wrapper');
				const $values = $wrp.find('.selectric-hide-select option');

				$values.parent()
					.find('option:selected')
					.prop('selected', false);

				$($values.get($wrp.find('.selected').index()))
					.prop('selected', true)
				.parent()
					.trigger('change');

				$wrp.addClass('is-selected');
			}
		});
	}

	/*
	* Init cursor trail line.
	*/
	const maxPointsCount = 122;
	const $cursorTrailLine = $('.js-draw-trail .cursor-trail__line');
	let pointsArray = [];

	/**
	 * Handle cursor trail points update on mousemove.
	 */
	$win.on('mousemove', function (event) {
		updateCursorTrailPoints(event);
	});

	/**
	 * Set & Update cursor trail container viewBox.
	 */
	$win.on('load resize', function () {
		$('.js-draw-trail').attr('viewBox', `0 0 ${window_width()} ${window_height()}`);
	});


	/**
	 * Handle scalable elements
	 */
	const $scalableElements = $('.js-scalable');

	setTransformData($scalableElements, true);
	setScalableData($scalableElements, true);
	updateScalableElementsTransform($scalableElements);

	$win.on('resize', function() {
		setTransformData($scalableElements, true);
		setScalableData($scalableElements, true);
		updateScalableElementsTransform($scalableElements);
	});

	$win.on('scroll', function() {
		updateScalableElementsTransform($scalableElements);
	});


	/**
	 * Handle Stats title animation.
	 */
	const $statsTitle = $('.section-stats.js-scroll-animation .section__title');

	if($statsTitle.length > 0) {
		const statsTitleObserver = new IntersectionObserver(function(entries) {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					$(entry.target).addClass('on-screen');
				}
			});
		}, {
			threshold: 0.7
		});

		$win.on('scroll resize', function() {
			if (($win.scrollTop() + window_height()) < $statsTitle.offset().top) {
				$statsTitle.removeClass('on-screen');
			}
		});

		statsTitleObserver.observe($statsTitle.get(0));
	}

	/**
	 * Photopile mobile scroll animation.
	 */
	const $photoPile = $('.section-info .section__item .component--image');

	if($photoPile.length > 0) {
		$photoPile.each(function () {
			const $this = $(this);

			const photoPileObserver = new IntersectionObserver(function(entries) {
				entries.forEach(entry => {
					if(entry.isIntersecting) {
						$(entry.target).find('.component--image').addClass('on-screen');
					}
				});
			}, {
				threshold: 0.3
			});

			$win.on('load scroll resize', function() {
				if (($win.scrollTop() + window_height()) < $this.offset().top) {
					$this.removeClass('on-screen');
				}
			});

			photoPileObserver.observe($this.parent().get(0));
		});
	}

	/**
	 * Init Selectric
	 */
	initSelectric($('select'));

	/**
	 * Handle Selectric init after Gravity Forms re-render
	 */
	$doc.on('gform_post_render', function() {
		initSelectric($('select'));
	});

	/**
	 * Handle light header toggle
	 */
	$('.header').toggleClass('is-light', getElementInnerScrollProgress('.hero-intro') >= 0.98);

	$win.on('scroll', function() {
		$('.header').toggleClass('is-light', getElementInnerScrollProgress('.hero-intro') >= 0.98);
	});

	/**
	 * Handle Hero Intro Video Button
	 */
	$('.hero-intro').toggleClass('hero--set', getElementInnerScrollProgress('.hero-intro') >= 0.97);

	$win.on('scroll', function() {
		$('.hero-intro').toggleClass('hero--set', getElementInnerScrollProgress('.hero-intro') >= 0.97);
	});

	/**
	 * Homepage scroll animations
	 */
	const observerConfig = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5
	};

	function intersectionCallback(entries) {
		entries.forEach(entry => {
			observerMap.set(entry.target, entry);
		});
	}

	const observerMap = new Map();
	const observer = new IntersectionObserver(intersectionCallback, observerConfig);

	$('.timeline > .section-timeline').each(function() {
		observer.observe(this);
	});


	$win.on('load', function() {
		if (!document.hidden) {
			setTimeout(function () {
				$('.timeline').each(function () {
					updateTimelineDisplay($(this));
				});
			}, 100);
		} else {
			$win.one('visibilitychange', function() {
				setTimeout(function () {
					$('.timeline').each(function () {
						updateTimelineDisplay($(this));
					});
				}, 100);
			});
		}
	});

	$win.on('scroll widthResize', function() {
		$('.timeline').each(function () {
			updateTimelineDisplay($(this));
		});
	});

	/**
	 * Init && Handle Sliders
	 */
	$win.on('widthResize', function() {
		initSliders();
	});

	/**
	* Handle CSS Variables
	*/
	setCSSVariable('dvh', window_height() * 0.01, 'px');
	setCSSVariable('current-dvh', window_height() * 0.01, 'px');
	setCSSVariable('dvw', window_width(), 'px');
	setCSSVariable('header-height', $header.outerHeight(), 'px');
	setCSSVariable('bar-height', $('.bar').outerHeight(), 'px');

	$win.on('resize', function() {
		setCSSVariable('current-dvh', window_height() * 0.01, 'px');
		setCSSVariable('header-height', $header.outerHeight(), 'px');
		setCSSVariable('bar-height', $('.bar').outerHeight(), 'px');
	});

	$win.on('widthResize', function() {
		setCSSVariable('dvh', window_height() * 0.01, 'px');
		setCSSVariable('dvw', window_width(), 'px');
	});

	/**
	 * Init splitting text to characters.
	 */
	Splitting({
		target: $('.js-splitting').get(0),
		by: 'chars'
	});

	/**
	 * Handle custom cursor.
	 */
	const $cursor = $('.cursor');
	let cursorYOnScroll = 0;

	$win.one('mousemove', function() {
		$cursor.addClass('is-moved');
	});

	$win
		.add($doc)
		.on('mousemove', updateCursorPosition);

	$win
		.add($doc)
		.on('mousemove', handleCursorState);

	$win.on('mouseleave', function() {
		$cursor.addClass('is-outside');
	});

	$win.on('mouseenter', function() {
		$cursor.removeClass('is-outside');
	});

	$doc.on('mousemove', function(event) {
		setCursorScaleValues();
	});

	$doc.on('scroll', handleCursorState);

	$html.on('mousewheel', updateCursorPosition);
	$html.on('mousewheel', handleCursorState);

	/**
	 * Cursor animation on click.
	 */
	const $externalLinks = $('a[href^="http://"]:not([target="_blank"]), a[href^="https://"]:not([target="_blank"]), a[href^="//"]:not([target="_blank"])');

	$externalLinks.on('click', function(event) {
		if($(this).closest('#wpadminbar').length > 0) {
			return;
		}

		event.preventDefault();

		$win.unbind('mousemove', handleCursorState);
		$doc.unbind('mousemove', handleCursorState);
		$html.unbind('mousewheel', handleCursorState);
		$doc.unbind('scroll', handleCursorState);

		$cursor.css('--current-x-position', $cursor.cursorX + 'px');
		$cursor.css('--current-y-position', $cursor.cursorY + 'px');

		$cursor.attr('data-color', '');

		$cursor.addClass('is-new-page');

		duration = 0.7;
		expandOuterCircle(0.7, 1, 0.43);
		history.pushState({}, '', window.location.pathname);

		setTimeout(() => {
			setTempCookie('cursorCoordinates', JSON.stringify({ x: getMouseX(), y: getMouseY(), color: $cursor.css('color') }), 1);
			window.location.href = $(this).attr('href');
		}, duration * 1000);
	});

	/**
	 * Scroll to target.
	 */
	const $scrollToLinks = $('a[href^="#"]:not([href="#"])');

	$scrollToLinks.on('click', function(event) {
		if($(this).hasClass('.js-scroll-next')) {
			return;
		}

		const $target = $($(this).attr('href'));

		if ($target.length > 0) {
			event.preventDefault();

			isNormalScroll = false;

			scrollToTarget($target);
		}
	});

	/**
	 * Hero animations.
	 */
	setOrderIndexes($('.hero-intro, .hero, .hero-panels .gateway'), $('[data-order-fade]'));

	/**
	 * Init Page transition canvas.
	 */
		//Uitlity
	const getMouseX = () => ($cursor.cursorX / window_width()) * 2 - 1;
	const getMouseY = () => ($cursor.cursorY / window_height() * -1) * 2 + 1;

		// Canvas
	const canvas = $('.cursor-canvas').get(0);

		// Scene
	const scene = new THREE.Scene();

		// Material
	const material = new THREE.ShaderMaterial({
		transparent: true,
		uniforms: {
			color: {
				value: new THREE.Color($cursor.css('color'))
			},
			innerRadius: {
				value: 0
			},
			outerRadius: {
				value: 0
			}
		},
		vertexShader: `
			varying vec2 vUv;
			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
			}
		`,
		fragmentShader: `
			uniform vec3 color;
			uniform float innerRadius;
			uniform float outerRadius;
			varying vec2 vUv;
			void main() {
				float dist = distance(vUv, vec2(0.5, 0.5));
				if (dist < innerRadius) discard;
				gl_FragColor = vec4(color, 1);
			}
		`
	});

		// Camera
	const camera = new THREE.PerspectiveCamera(75, window_width() / window_height(), 0.1, 100);

	scene.add(camera);

		//Geometry
	let geometry = new THREE.CircleGeometry(.1, 128);

		//Mesh
	const circle = new THREE.Mesh(geometry, material);
	circle.position.set(0, 0, -1);
	scene.add(circle);

		//Properties
	let outerCircleProperties = {
		radius: .1,
		vectorZ: 1,
		geometry: 0.1
	};

	let innerCircleProperties = {
		radius: .01,
		vectorZ: 1,
	};

		//Vector
	let vector = new THREE.Vector3(getMouseX(), getMouseY(), outerCircleProperties.vectorZ);
	vector.unproject(camera);

	circle.position.copy(vector);

		// Renderer
	const renderer = new THREE.WebGLRenderer({
		canvas: canvas,
		alpha: true,
		antialias: true
	});

	renderer.setSize(window_width(), window_height());
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

		// Animate
	function tick() {
		renderer.render(scene, camera)

		window.requestAnimationFrame(tick);
	};

	tick();

		// Handlers
	$win.on('resize', function() {
		camera.aspect = window_width() / window_height();
		camera.updateProjectionMatrix();

		renderer.setSize(window_width(), window_height());
		renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
	});

	const updateCirclePosition = () => {
		vector = new THREE.Vector3(getMouseX(), getMouseY(), outerCircleProperties.vectorZ);
		vector.unproject(camera);

		circle.position.copy(vector);
	};

	/**
	 * Stats Numbers hover.
	 */
	let statsChangeTimeout;

	$('.js-stats .js-stats-text li').on('mouseover', function() {
		const index = $(this).index();
		const $container = $(this).closest('.js-stats');

		clearTimeout(statsChangeTimeout);

		statsChangeTimeout = setTimeout(() => {
			$container.find('.js-stats-media.slick-initialized').slick('slickGoTo', index+1);
		}, 375);

		$(this).addClass('hover').siblings().removeClass('hover');
	}).on('mouseleave', function() {
		const $container = $(this).closest('.js-stats');
		$container.find('.js-stats-media picture').removeClass('is-current');
	});

	/**
	 * Init Photo Pile Scroll Animation.
	 *
	 * @param {jQuery} container
	 */
	function initPhotoPileScrollAnimation(container) {
		const $container = $(container);
		const $items = $container.find('.section__item > *:first-child');
		const $marquee = $container.find('.section__marquee');

		$items.each(function() {
			setTransformData($(this), true);
		});

		setTransformData($marquee, true);

		$win.on('resize', function() {
			$items.each(function() {
				setTransformData($(this), true);
			});

			setTransformData($marquee, true);
		});

		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function () {
				//Create pinned section
				ScrollTrigger.create({
					trigger: $container.get(0),
					start: () => `top top`,
					end: () => `+=300%`,
					pin: true,
					scrub: true
				});

				//Move photo pile and revel text.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: `top top`,
					end: `40% 40%`,
					scrub: true,
					onUpdate: (self) => {
						$items.each(function() {
							const $item = $(this);
							const transformData = $item.data('transform');

							const newTranslateX = calculateInterpolateValue(transformData.x, 0, self.progress);
							const newTranslateY = calculateInterpolateValue(transformData.y, 0, self.progress);

							$item.css('transform', `translate3d(${newTranslateX}px, ${newTranslateY}px, 0)`);
						});

						$container.find('.section__entry').toggleClass('is-visible', self.progress >= 1);
					}
				});

				//Move marquee.
				ScrollTrigger.create({
					trigger: $container.parent().get(0),
					start: `40% 40%`,
					end: `120% 120%`,
					scrub: 10,
					onUpdate: (self) => {
						const marqueeTransformX = $marquee.data('transform').x;
						const marqueeWidth = $marquee.outerWidth();

						// Adjust the transition amount based on the marquee width
						const transitionAmount = marqueeWidth * 0.25;

						$marquee.css('transform', `rotate(-13.299deg) translate3d(${calculateInterpolateValue(marqueeTransformX, transitionAmount, self.progress * 0.5)}px, -50%, 0)`);
					}
				});
			}
		});
	}

	/**
	 * Handle aspect-ratio font-size set.
	 */
	setAspectRatioFontSize();

	$win.on('resize', function() {
		setTimeout(setAspectRatioFontSize, 500);
	});

	/**
	 * Handle Lottie animations.
	 *
	*/
	const $lottieContainers = $('.js-lottie').filter(function() {
		return ($(this).closest('.slick-slide:not(.slick-active)').length === 0 || $(this).closest('.slick-slide').index() === 0)
			&& $(this).closest('.hero__background').length === 0;
	});

	/**
	 * Init Zoomist Container.
	 */
	initZoomist();

	/**
	 * Init Isotope.
	 */
	const $listingTable = $('.js-listing .listing__table');

	setOrderIndexes($listingTable, $listingTable.find('tr'));

	let filterTimeout;

	$('.js-listing .listing__nav ul').on('click', 'a', function(e) {
		e.preventDefault();
		const filterValue = $(this).data('option');
		const $container = $(this).closest('.js-listing');
		const $items = $container.find(`.listing__table tbody > tr`);
		const $filteredItems = $container.find(`.listing__table tbody > ${filterValue}`);

		$container.addClass('transitioning');

		clearTimeout(filterTimeout);

		filterTimeout = setTimeout(() => {
			$items.addClass('not-selected').hide();

			setOrderIndexes($container, $filteredItems);

			$filteredItems.show();

			setTimeout(() => {
				$filteredItems.removeClass('not-selected');
				$container.removeClass('transitioning');
			}, 200);
		}, 300);

		$('.listing__nav ul li').removeClass('is-current');
		$(this).parent().addClass('is-current');
	});

	/**
	 * Init News Filter
	 */

	let newsFilterTimeout;

	function filterNewsItems(filterValue, $clickedElement) {
		const $parent = $clickedElement.parents('.mosaic').eq(0);
		const $container = $parent.find('.mosaic__grid');
		const $items = $container.find('.mosaic__item');
		const $filteredItems = $container.find(`.mosaic__item${filterValue}`);

		$container.addClass('transitioning');

		clearTimeout(newsFilterTimeout);

		newsFilterTimeout = setTimeout(() => {
			$items.addClass('not-selected').hide();

			setOrderIndexes($container, $filteredItems);

			$filteredItems.show();

			setTimeout(() => {
				$filteredItems.removeClass('not-selected');
				$container.removeClass('transitioning');
			}, 200);
		}, 300);

		$('.js-news-filter ul li').removeClass('is-current');
		$clickedElement.parent().addClass('is-current');
	}

	$('.js-news-filter ul li').on('click', 'a', function(e) {
		e.preventDefault();
		const filterValue = $(this).data('option');
		filterNewsItems(filterValue, $(this));
	});

	$('.js-news-filter select').on('change', function() {
		const filterValue = $(this).val();
		console.log(filterValue);
		filterNewsItems(filterValue, $(this));
	});

	/**
	 * Init Residence Filter
	 */

	let residenceFilterTimeout;

	function filterResidenceItems(filterValue, $clickedElement) {
		const $parent = $clickedElement.parents('.mosaic').eq(0);
		const $container = $parent.find('.mosaic__grid');
		const $items = $container.find('.mosaic__item');
		const $filteredItems = $container.find(`.mosaic__item${filterValue}`);

		$container.addClass('transitioning');

		clearTimeout(residenceFilterTimeout);

		residenceFilterTimeout = setTimeout(() => {
			$items.addClass('not-selected').hide();

			setOrderIndexes($container, $filteredItems);

			$filteredItems.show();

			setTimeout(() => {
				$filteredItems.removeClass('not-selected');
				$container.removeClass('transitioning');
			}, 200);
		}, 300);

		$('.js-residence-filter ul li').removeClass('is-current');
		$clickedElement.parent().addClass('is-current');
	}

	$('.js-residence-filter ul li').on('click', 'a', function(e) {
		e.preventDefault();
		const filterValue = $(this).data('option');
		filterResidenceItems(filterValue, $(this));
	});

	$('.js-residence-filter select').on('change', function() {
		const filterValue = $(this).val();
		console.log(filterValue);
		filterResidenceItems(filterValue, $(this));
	});


	// On Window load, click the data-option filter option '.now-selling' on the residence filter
	$win.on('load', function() {
		$('.js-residence-filter ul li a[data-option=".now-selling"]').click();
	});

	$doc.on('click', '.js-scroll-to-top', function(e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		}, 800);
	});


	/**
	 * Header Slide Up handle.
	 */
	setOrderIndexes($('.header .nav'), $('.header .nav > ul > li'));

	let previousScroll = $win.scrollTop();

	$win.on('scroll widthResize', function(e) {
		var currentScroll = $win.scrollTop();
		var isNotAtTop = currentScroll > 0;
		var isScrollingDown = currentScroll > previousScroll;
		var isHeroIntroScrolled = $('.hero-intro').length == 0 || getElementInnerScrollProgress('.hero-intro') >= 0.97;
	
		$header.toggleClass('header--up',
			isNotAtTop && isScrollingDown && isHeroIntroScrolled
		);

		// Prevent animated from repeating more than once after user has interacted with scrolling
		if( isNotAtTop && isScrollingDown && isHeroIntroScrolled ) {
			$('.nav ul li').addClass("animated");
		}
	
		previousScroll = currentScroll;
	});

	/**
	 * Init Section Animations.
	 */
	const animationMap = {
		'section-info' : initPhotoPileScrollAnimation,
		'section-stats' : initStatsScrollAnimation,
		'section-gateway': initGatewaysScrollAnimation,
		'section-accordion': initAccordionScrollAnimation,
		'section-text-slider': initTextSliderScrollAnimation,
		'section-projects': initProjectsScrollAnimation,
		'section-media-slider': initMediaSliderScrollAnimation,
		'section-features': initFeaturesSliderScrollAnimation,
	}

	function initAnimatedSections() {
		$('.js-scroll-animation').each(function() {
			const $this = $(this);

			$.each($this[0].classList, function(index, className) {
				if(animationMap.hasOwnProperty(className)) {
					animationMap[className]($this);
					return;
				}
			});
		});
	}

	/**
	 * Handle Nav toggle.
	 */
	const menuTransitionDuration = 200;
	let menuTimeout;

	$('.nav-btn').on('click', function(event) {
		event.preventDefault();

		const $body = $('body');

		if(!$body.hasClass('nav-open')) {
			$body.addClass('nav-transition');

			setTimeout(() => {
				$body.addClass('nav-open');
			}, menuTransitionDuration);
		} else {
			$body.removeClass('nav-open');

			setTimeout(() => {
				$body.removeClass('nav-transition');
			}, 0);
		}
	});

	/**
	 * Scroll to Next section
	 */
	$('.js-scroll-next').on('click', function(event) {
		event.preventDefault();

		passiveScrollToTarget($(this).closest('section, .hero-intro, .hero').next());
	});

	// $('.timeline__nav a').on('click', function(event) {
	// 	event.preventDefault();

	// 	passiveScrollToTarget($($(this).attr('href')));
	// });

	/**
	 * Toggle is-touch-device class.
	 */
	$win.on('load widthResize resize', function() {
		$('body').toggleClass('is-touch-device', isTouchDevice());
	});

	/**
	 * Set entry-height variable
	 */
	const $gallerySection = $('.section-gallery');
	setCSSVariable('entry-height', $gallerySection.find('.section__entry--mobile').outerHeight(), 'px', $gallerySection);

	$win.on('widthResize', function(event) {
		setCSSVariable('entry-height', $gallerySection.find('.section__entry--mobile').outerHeight(), 'px', $gallerySection);
	});


	/**
	 * Scroll lottie.
	 */
	function isAppleDevice() {
		const appleDevices = /iPhone|iPad|iPod|Macintosh/;
		return appleDevices.test(navigator.userAgent);
	}

	$('.js-scroll-gallery').each(function () {
		const $container = $(this);
		const animations = $container.find('.js-lottie-scroll').map(function () {
			const $this = $(this);

			const animation = lottie.loadAnimation({
				container: $this.get(0),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				assetsPath: '',
				path: $this.data('src')
			});

			animation.setSpeed($this.data('speed'));

			animation.addEventListener('DOMLoaded', function() {
			});

			return animation;
		}).get();

		$container.toggleClass('is-apple', isAppleDevice());

		$win.on('load widthResize', function() {
			let scrollTrigger;
		
			scrollTrigger = ScrollTrigger.create({
				trigger: $container.get(0),
				start: () => window_width() < 768 ? '30% 30%' : '-10% -25%',
				end: () => window_width() < 768 ? '150% 150%' : '105% 105%',
				scrub: 0.5, // Add smoothing to the scrub
				onUpdate: self => {
					animations.forEach(animation => {
						const totalFrames = animation.totalFrames;
						
						// Use lerp for smoother frame transitions
						const currentFrame = animation.currentFrame;
						const targetFrame = Math.floor(self.progress * totalFrames);
						const lerpedFrame = lerp(currentFrame, targetFrame, 0.1);
						
						animation.goToAndStop(lerpedFrame, true);
					});
		
					if (self.progress === 1) {
						animations.forEach(animation => {
							animation.goToAndStop(animation.totalFrames - 1, true);
						});
		
						if(scrollTrigger) {
							scrollTrigger.kill();
						}
					}
				}
			});
		});
		
		// Helper function for linear interpolation
		function lerp(start, end, amt) {
			return (1 - amt) * start + amt * end;
		}
	});

	/**
	 * Mobile Projects Accordion.
	 */
	$('.section-projects .section__nav h3').on('click', function() {
		const $this = $(this);

		if(isBreakpoint('tablet', true)) {
			$this.siblings('.section__nav-info')
				.stop()
				.slideToggle()
			.closest('li')
				.toggleClass('is-current')
			.siblings()
				.removeClass('is-current')
			.find('.section__nav-info')
				.stop()
				.slideUp();
		}
	});

	/**
	 * Toggle accordion
	 */
	$('.js-accordion').on('click', '.accordion__head', function(event) {
		toggleAccordion($(this));
	});


	/**
	 * Accordion set order indexes.
	 */
	setOrderIndexes($('.section-accordion.js-scroll-animation'), $('.accordion__section:not(:first-child)'));

	/**
	 * Projects hover handler.
	 */
	let changeTimeout;

	$('.js-project-nav li a').on('mouseenter', function(event) {
		event.preventDefault();

		const $container = $(this).closest('.js-projects');
		const $slider = $container.find('.js-slider-media .slick-initialized');

		if(!$slider.length > 0) {
			return;
		}

		$slider.removeClass('is-autoplay');

		clearTimeout(changeTimeout);

		$(this).closest('li')
			.addClass('hover')
		.siblings()
			.removeClass('hover');

		$slider.slick('slickPause');

		changeTimeout = setTimeout(() => {
			$slider.slick('slickGoTo', $(this).closest('li').index());
		}, 375);
	}).on('mouseleave', function(event) {
		const $container = $(this).closest('.js-projects');
		const $slider = $container.find('.js-slider-media .slick-initialized');

		if(!$slider.length > 0) {
			return;
		}

		clearTimeout(changeTimeout);

		changeTimeout = setTimeout(() => {
			$slider.slick('slickPlay');
			$slider.addClass('is-autoplay');
		}, 1000);
	});

	$('.section-projects--alt .js-project-nav li a').on('click', function(event) {
		event.preventDefault();

		const $container = $(this).closest('.js-projects');
		const $slider = $container.find('.js-slider-media .slick-initialized');

		if(!$slider.length > 0) {
			return;
		}

		$slider.slick('slickGoTo', $(this).closest('li').index());
	});


	/**
	 * Sticky stats.
	 */
	function setStatsCSSVariables() {
		const $statsContainer = $('.stats > ul');

		$statsContainer.each(function() {
			let statsHeight = 0;
			$(this).css('--extra-height', '');

			$(this).find('>li').each(function() {
				const $this = $(this);

				$this.css('--current-height', 'auto');

				const currentHeight = $this.outerHeight(true);

				setCSSVariable('current-height', currentHeight, 'px', $this);
				$this.css('--sticky-top', '');
				setCSSVariable('sticky-top', statsHeight, 'px', $this);

				statsHeight += $this.find('>a').outerHeight();
			});

			setCSSVariable('extra-height',  $(this).outerHeight() + statsHeight, 'px', $(this));
		});
	}

	setStatsCSSVariables();

	$win.on('widthResize', function() {
		setStatsCSSVariables();
	});


	/**
	 * Add form section animation.
	 */
	const $sectionForm = $('.section-form');

	if ($sectionForm.prev('.timeline').length > 0) {
		const observer = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					$(entry.target).css('--scale', `${Math.max($(entry.target).outerHeight(), window_width()) * 2.5}px`);
					$(entry.target).find('.shell').addClass('is-visible');

					observer.unobserve(entry.target);
				}
			});
		  }, {
			threshold: 0.55
		});

		observer.observe($sectionForm.get(0));
	}



	/**
	 * On Load Inits.
	 */
	initCountUp();
	initAnimatedSections();

	$win.on('load', function() {
		initMap();
		initFilteredMap();
		initVideos();

		setTimeout(() => {
			expandOuterCircle(0, 1, 0.43, true);
		}, 500);

		setTimeout(() => {
			$('.header').removeClass("header--up");
		}, 300);

		setTimeout(() => {
			initLotties();
		}, 700);
	});
})(jQuery, window, document);